import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
  fr: {
    // Intro Page
    welcome: "Bienvenue chez",
    tagline: "Soyez l'architecte de la bague de vos rêves",
    taglineSubtitleLine1: "La première Maison de joaillerie au monde à mettre la création entre vos mains :",
    taglineSubtitleLine2: "De la sélection de votre pierre au choix du design, visualisez votre création portée avant même le lancement de sa fabrication dans nos ateliers.",
    startDesigning: "Commencer la création",
    discoverHouse: "Découvrir la Maison",
    signIn: "Connexion",
    signUp: "Inscription",
    myCreations: "Mes Créations",
    myAccount: "Mon Espace",
    logout: "Déconnexion",
    
    // About Page Hero
    aboutHeroSubtitle: "La première Maison de joaillerie au monde à mettre la création entre vos mains :",
    aboutHeroSubtitle2: "De la sélection de votre pierre au choix du design, visualisez votre création portée avant même le lancement de sa fabrication dans nos ateliers.",
    createYourRing: "Créer votre bague",
    
    // Creation Steps
    processLabel: "Processus",
    creationStepsTitle: "Les étapes de création",
    step: "Étape",
    stoneChoiceTitle: "Le choix de la pierre",
    stoneChoiceDesc: "Sélectionnez la pierre idéale parmi notre large gamme de saphirs, émeraudes, rubis, tourmalines, grenats et bien d'autres. Toutes nos pierres sont certifiées par des laboratoires renommés. Grâce à nos bureaux situés en Inde, au Sri Lanka et à Bangkok, au cœur des marchés et des mines, nous avons un accès privilégié aux plus belles pierres, en avant-première.",
    designTitle: "Le design",
    designDesc: "Sélectionnez le design qui vous correspond ou envoyez-nous vos photos d'inspiration. Choisissez le métal et personnalisez chaque détail de votre bague. Et si le design final ne vous satisfait pas entièrement, notre designer pourra créer une version sur-mesure, parfaitement adaptée à vos envies et à votre style.",
    manufacturingTitle: "La fabrication",
    manufacturingDesc: "Votre création est réalisée à la main dans nos ateliers en Thaïlande, en Italie et en France par nos maîtres artisans. Suivez l'avancée de la fabrication de votre bague directement via votre espace personnel, de la conception jusqu'à la livraison.",
    
    // FAQ
    faqLabel: "FAQ",
    faqTitle: "Questions fréquentes",
    faq1Question: "Comment se déroule la création sur mesure ?",
    faq1Answer: "Depuis votre compte personnel, vous accédez à notre espace de discussion, où vous pouvez échanger directement avec nos équipes sur vos envies, votre histoire et votre budget. Dans cet espace, vous pourrez apporter toutes les modifications nécessaires, qu'il s'agisse du choix de la pierre ou du design, afin de créer la bague de vos rêves.\n\nNos experts vous guideront dans la sélection de la pierre idéale pour votre projet. Si le design généré ne correspond pas parfaitement à vos attentes, nos designers peuvent intervenir pour proposer des créations entièrement personnalisées. Une fois tous les éléments validés, vous aurez accès à votre devis. Sa validation déclenche la réalisation de votre bague par nos artisans joailliers, façonnée à la main selon les plus hauts standards d'excellence de la Maison Bonnot Paris.",
    faq2Question: "Est-ce que vos pierres sont certifiées ?",
    faq2Answer: "Oui, toutes nos pierres sont certifiées par des laboratoires de renom tels que Bellerophon, ICA GemLab, London Gem Lab, et d'autres encore, garantissant leur authenticité et leur qualité exceptionnelle.",
    faq3Question: "Comment se passe la livraison de mon bijou sur mesure ?",
    faq3Answer: "La livraison s'effectue en main propre à Paris ou via un transporteur spécialisé, afin de garantir une expédition sécurisée, assurée et entièrement fiable jusqu'à destination.",
    faq4Question: "Quels sont les délais de création ?",
    faq4Answer: "Le délai de réalisation dépend de la complexité du bijou, mais il faut généralement compter entre 4 et 8 semaines après la validation du devis.",
    faq5Question: "Puis-je réutiliser mon or pour ma création ?",
    faq5Answer: "Nous proposons un service de recyclage et de transformation de vos bijoux. L'or de vos pièces existantes peut être réutilisé afin de leur offrir une nouvelle vie, au cœur d'une création imaginée spécialement pour vous.\n\nSi vous souhaitez concevoir votre bijou à partir de votre propre or, nous vous invitons à nous l'indiquer en cliquant sur le bouton « Je souhaite réutiliser mon or pour ma bague » à l'étape 2, ou directement via l'espace de discussion accessible depuis votre compte.",
    faq6Question: "Et si je ne peux pas me déplacer à Paris ?",
    faq6Answer: "Nous accompagnons de nombreux clients à travers la France et à l'international. Depuis votre espace personnel, vous pouvez nous transmettre vos questions et vos doutes à tout moment. Nos équipes restent à votre écoute et vous accompagnent avec attention tout au long du processus de création.",
    
    // Configure Page - Reuse Gold
    reuseGoldTitle: "Réutiliser votre or",
    reuseGoldSubtitle: "Nous ne reprenons que l'or 18k 750",
    reuseGoldToggle: "Je souhaite réutiliser mon or pour ma bague",
    reuseGoldToggleDesc: "Nous fondrons votre or pour créer votre nouvelle bague",
    goldWeightLabel: "Poids de votre or (en grammes)",
    goldWeightPlaceholder: "Ex: 15",
    goldWeightHelp: "Si vous ne connaissez pas le poids exact, laissez ce champ vide. Nous le déterminerons ensemble.",
    
    // Configure Page - Metal
    metalTitle: "Métal",
    metalSubtitle: "Choisissez votre métal précieux",
    
    // Configure Page - Ring Size
    ringSizeTitle: "Tour de doigt",
    ringSizeSubtitle: "Taille standard femme : 53",
    ringSizeUnknown: "Je ne connais pas ma taille",
    
    // Configure Page - Budget
    budgetTitle: "Budget",
    budgetSubtitle: "Estimation pour votre projet",
    
    // About Page
    aboutTitle: "La Maison Bonnot Paris",
    aboutSubtitle: "Haute Joaillerie depuis 1987",
    aboutDescription1: "Depuis plus de 35 ans, la Maison Bonnot Paris incarne l'excellence de la haute joaillerie française. Notre atelier parisien perpétue un savoir-faire artisanal d'exception, transmis de génération en génération.",
    aboutDescription2: "Chaque création est le fruit d'une collaboration unique entre nos maîtres joailliers et vous. De la sélection de la pierre précieuse à la conception finale, nous vous accompagnons pour donner vie à la bague de vos rêves.",
    aboutDescription3: "Grâce à notre technologie d'intelligence artificielle, visualisez instantanément vos idées et explorez des designs personnalisés avant de les confier à nos artisans.",
    ourValues: "Nos Valeurs",
    valueExcellence: "Excellence",
    valueExcellenceDesc: "Un savoir-faire artisanal d'exception",
    valueCreativity: "Créativité",
    valueCreativityDesc: "Des designs uniques et personnalisés",
    valueQuality: "Qualité",
    valueQualityDesc: "Les plus belles pierres précieuses",
    backToHome: "Retour",
    readyToCreate: "Prêt à créer ?",
    
    // Navigation
    upload: "Pierre",
    design: "Design",
    configure: "Paramètres",
    designs: "Designs",
    results: "Votre Création",
    quote: "Devis",
    
    // Gemstone Page
    selectGemstone: "Sélectionnez votre pierre précieuse",
    uploadYourStone: "Uploadez votre pierre",
    orChooseFromCatalog: "Ou choisissez dans notre catalogue",
    continue: "Continuer",
    
    // Configuration Page
    selectMetal: "Choisissez votre métal",
    yellowGold: "Or Jaune",
    whiteGold: "Or Blanc",
    roseGold: "Or Rose",
    platinum: "Platine",
    selectInspiration: "Choisissez vos inspirations",
    generateDesigns: "Générer les designs",
    inspirationSelected: "1 inspiration sélectionnée",
    
    // Results Page
    yourDesigns: "Vos Designs",
    selectVariation: "Sélectionnez une variation",
    refine: "Affiner",
    wornView: "Vue portée",
    virtualTryOn: "Essayage virtuel",
    requestQuote: "Demander un devis",
    
    // Quote Page
    quoteRequest: "Demande de devis",
    selectedDesign: "Design sélectionné",
    estimatedPrice: "Prix estimé",
    contactInfo: "Informations de contact",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    message: "Message",
    submit: "Envoyer",
    
    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    back: "Retour",
    next: "Suivant",

    // Upload/Catalog Page
    ourCatalog: "Notre Catalogue",
    selectYourGemstone: "Sélectionnez votre pierre précieuse",
    filters: "Filtres",
    filterType: "Type",
    filterPrice: "Prix",
    filterWeight: "Poids",
    filterShape: "Forme",
    filterClarity: "Clarté",
    filterTreatment: "Traitement",
    filterOrigin: "Origine",
    search: "Rechercher",
    video: "Vidéo",
    continueBtn: "Continuer",
    backBtn: "Retour",

    // Configure Page
    stepLabel: "ÉTAPE",
    preciousStone: "PIERRE PRÉCIEUSE",
    configuration: "CONFIGURATION",
    personalizeCreation: "Personnalisez Votre Création",
    selectPreferences: "Sélectionnez vos préférences pour créer la bague parfaite",
    chooseYourStone: "Choisissez Votre Pierre",
    yourChoices: "Vos choix",

    // Metal
    metalTitle: "Métal",
    metalSubtitle: "Choisissez votre métal précieux",

    // Engraving
    engravingTitle: "Gravure",
    engravingSubtitle: "Ajoutez un message personnel à l'intérieur de la bague",
    addEngraving: "Ajouter une gravure",
    maxChars: "Jusqu'à 20 caractères",

    // Ring Size
    ringSizeTitle: "Taille de bague",
    dontKnowSize: "Je ne connais pas ma taille",

    // Budget
    budgetTitle: "Budget",
    budgetSubtitle: "Estimation pour votre projet",
    andMore: "et plus",

    // Reuse Gold
    reuseGoldTitle: "Réutiliser votre or",
    reuseGoldSubtitle: "Nous ne reprenons que l'or 18k 750",
    reuseGoldYes: "Oui, je souhaite réutiliser mon or",
    goldWeightLabel: "Poids estimé de l'or (grammes)",

    // Generation Loading
    creationInProgress: "Création en cours",
    aiGenerating: "Notre IA génère vos designs sur mesure",
    analyzingStone: "Analyse de votre pierre précieuse",
    generatingMainDesign: "Génération du design principal (A)",
    creatingVariations: "Création des variations (B & C)",
    estimatedTime: "Temps estimé",
    aboutSeconds: "environ 1 à 2 minutes",

    // UserInspirationUpload
    uploadTitle: "Votre Inspiration",
    uploadDesc: "Choisissez un design Bonnot Paris ou uploadez votre propre inspiration. L'IA utilisera cette référence pour créer votre bague.",
    copyrightWarning: "Pour éviter toute reproduction illégale de bagues existantes, nous vous recommandons d'utiliser nos inspirations Bonnot Paris, ou des images libres de droits. Merci de ne pas télécharger de photos de bagues appartenant à d'autres marques.",
    dropOrClick: "Glissez votre image ou cliquez pour uploader",
    pngJpgPdf: "PNG, JPG, PDF — 1 image maximum",
    maxOneUpload: "Vous ne pouvez uploader qu'une seule inspiration.",
    alreadyUploadedInsp: "Vous avez déjà uploadé votre inspiration. Supprimez-la pour en choisir une autre.",

    // Language names
    langFrench: "Français",
    langUSEnglish: "Américain",
    langUKEnglish: "Anglais",
    langGerman: "Allemand",
    langSpanish: "Espagnol",

    // Trust Badges - Stone
    trustNoMiddleman: "Sans intermédiaire",
    trustNoMiddlemanDesc: "La seule maison de joaillerie à disposer de bureaux au Sri Lanka, en Inde et en Thaïlande",
    trustNaturalStone: "Pierre naturelle",
    trustNaturalStoneDesc: "Nos gemmes uniques reflètent la pureté et l'élégance de la nature",
    trustCertificate: "Livrée avec certificat",
    trustCertificateDesc: "Exclusivement par des laboratoires indépendants renommés",
    trustICA: "Membre ICA",
    trustICADesc: "International Colored Gemstone Association",
    // Trust Badges - Creation
    trustHandmade: "Fabrication à la main",
    trustHandmadeDesc: "Chaque bijou en or 18 carats, témoignant de notre engagement qualité",
    trustExpertise: "Savoir-faire séculaire",
    trustExpertiseDesc: "Des ateliers avec des centaines d'années d'expérience",
    trustResize: "Remise à taille offerte",
    trustResizeDesc: "Ajustement gratuit pour un confort parfait",
    trustReviews: "70 avis — 5/5 Google",
    trustReviewsDesc: "Nos clients témoignent de leur satisfaction",
    trustShipping: "Envoi international sécurisé",
    trustShippingDesc: "Livraison assurée dans le monde entier",
    trustDelay: "Délai : 4 à 6 semaines",
    trustDelayDesc: "Fabrication artisanale sur mesure",

    // Design Catalog
    ourDesigns: "Nos Designs",
    designsForShape: "design(s) pour votre forme de pierre",
    selectStoneForDesigns: "Sélectionnez une pierre pour voir les designs adaptés",
    noDesignsForShape: "Aucun design disponible pour cette forme",
    selectStoneToSee: "Sélectionnez une pierre pour voir les designs",

    // User Inspiration Upload
    yourInspiration: "Votre Inspiration",
    addYourImage: "Ajoutez votre propre image d'inspiration (PNG, JPEG, PDF)",
    oneImage: "1 image",
    complete: "Complet",
    alreadyUploaded: "Vous avez déjà uploadé votre inspiration. Supprimez-la pour en choisir une autre.",
    dropImageHere: "Déposez votre image ici",
    dragOrClick: "Glissez votre image ou cliquez pour uploader",
    oneImageMax: "PNG, JPG, PDF — 1 image maximum",
    chooseDesignOrUpload: "Choisissez un design Bonnot Paris ou uploadez votre propre inspiration. L'IA utilisera cette référence pour créer votre bague.",
    copyrightNotice: "Pour éviter toute reproduction illégale de bagues existantes, nous vous recommandons d'utiliser nos inspirations Bonnot Paris, ou des images libres de droits.",

    // Refinement Panel
    refineDesign: "Affiner le design",
    selectModifications: "Sélectionnez les modifications souhaitées",
    initialDesign: "Design initial",
    bandStructure: "Structure de l'anneau",
    bandWithDiamonds: "Anneau serti de diamants",
    bandNoDiamonds: "Anneau sans diamants",
    removeAllPave: "Supprimer tous les pavages",
    secondaryStones: "Pierres secondaires",
    replaceColorWithDiamond: "Remplacer les pierres de couleur par des diamants",
    settingType: "Type de sertissage",
    prongsEagle: "Sertissage griffes",
    prongsRound: "Griffes rondes",
    bezelSetting: "Sertissage clos",
    metalType: "Métal",
    singleOptionOnly: "Une seule option possible",
    modificationsSelected: "modification(s) sélectionnée(s)",
    generateNewVersion: "Générer une nouvelle version",
    generationInProgress: "Génération en cours...",
    selectAtLeastOne: "Sélectionnez au moins une modification",

    // Account Dashboard
    myRequests: "Mes demandes",
    myCreationsTab: "Mes Créations",
    messaging: "Messagerie",
    fabricationTracking: "Suivi fabrication",
    faqHelp: "FAQ & Aide",
    mySpace: "Mon Espace",
    logout: "Déconnexion",
    noCreations: "Aucune création",
    creationsWillAppear: "Vos designs générés apparaîtront ici.",
    noFabrication: "Aucun projet en fabrication",
    fabricationWillAppear: "Une fois votre devis validé, vous pourrez suivre l'avancement ici",
    estimatedDelivery: "Livraison estimée",
    writeMessage: "Écrivez votre message...",
    messageSent: "Message envoyé",
    noMessages: "Nous vous transmettrons votre devis sous 48 heures. N'hésitez pas à nous communiquer toutes les informations nécessaires concernant votre création.",
    bonnotTeam: "L'équipe Bonnot Paris",
    contactByEmail: "Nous contacter par email",

    // Auth Modal
    connection: "Connexion",
    accessCreations: "Accédez à vos créations",
    createAccount: "Créer un compte",
    saveDesigns: "Sauvegardez vos designs préférés",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordTitle: "Mot de passe oublié",
    forgotPasswordDesc: "Entrez votre email pour recevoir un lien de réinitialisation",
    newPassword: "Nouveau mot de passe",
    newPasswordDesc: "Choisissez votre nouveau mot de passe",
    sendLink: "Envoyer le lien",
    resetPassword: "Réinitialiser le mot de passe",
    emailSent: "Email envoyé !",
    emailSentDesc: "Si un compte existe avec cet email, vous recevrez un lien pour réinitialiser votre mot de passe.",
    backToLogin: "Retour à la connexion",
    noAccount: "Pas encore de compte ?",
    alreadyAccount: "Déjà un compte ?",
    connecting: "Connexion...",
    creating: "Création...",
    sending: "Envoi...",
    resetting: "Réinitialisation...",

    // Results Page
    personalizeDesign: "Personnalisez votre design",
    seeWorn: "Voir Porté",
    wornViewsGenerated: "Vues portées générées",
    generateWornViews: "Générer des vues portées",
    tryOnHand: "Essayer sur ma main",
    tryOnHandDesc: "Visualiser avec votre photo",
    refineDesignBtn: "Affiner le design",
    refineDesignDesc: "Modifier des détails",
    validateDesign: "Valider ce design",
    designSaved: "Ce design sera sauvegardé dans \"Mes Créations\"",
    tip: "Conseil",
    tipSelection: "Cliquez sur le design qui vous plaît le plus pour le personnaliser.",
    tipCustomization: "Utilisez les options pour voir le design porté ou l'affiner avant de valider.",

    // Fabrication Steps
    stoneValidation: "Validation de la pierre",
    designValidation: "Validation du design",
    quoteValidation: "Validation du devis",
    depositPayment: "Versement de l'acompte",
    waxCreation: "Réalisation de la cire",
    workshopFabrication: "Fabrication dans nos ateliers",
    photoShooting: "Shooting de la bague",
    shippingDelivery: "Expédition / Remise en main propre",
    finalPayment: "Règlement du solde",
    delivered: "Livré",

    // Bottom Bar
    stoneLabel: "Pierre",
    designLabel: "Design",
    designChosen: "Sélectionné",
    yourDesignLabel: "Votre design",
    notChosen: "Non choisi",
    metalLabel: "Métal",
    sizeLabel: "Taille",
    sizeNotChosen: "Non choisie",
    budgetLabel: "Budget",
    budgetDefined: "Défini",
    budgetNotDefined: "Non défini",
    generate: "Générer",
    generating: "Génération...",

    // Results Page
    chooseYourStyle: "Choisissez Votre Style",
    selectMatchingDesign: "Sélectionnez le design qui vous correspond",
    adjustDesign: "Ajustez le design selon vos envies",
    selection: "Sélection",
    chooseStyleDesc: "Sélectionnez le design qui vous séduit le plus, puis adaptez-le selon vos envies et votre style.",
    clickToCustomize: "Cliquez sur un design pour le personnaliser",
    optionsTitle: "Options de personnalisation",
    seeWornBtn: "Voir Porté",
    wornGenerated: "Vues portées générées",
    generateWorn: "Générer des vues portées",
    tryOnBtn: "Essayer sur ma main",
    tryOnDesc: "Visualiser avec votre photo",
    refineBtn: "Affiner le design",
    refineDesc: "Modifier des détails",
    validateBtn: "Demander mon devis gratuit",
    savedInCreations: "Ce design sera sauvegardé dans \"Mes Créations\"",
    tipLabel: "Conseil",
    tipClickDesign: "Cliquez sur le design qui vous plaît le plus pour le personnaliser.",
    designRefined: "Design affiné ! Les vues portées ont été réinitialisées.",
    selectOneMod: "Sélectionnez au moins une modification",
    personalizeYourDesign: "Personnalisez votre design",
    generationSuccess: "Génération réussie !",
    generationError: "Erreur lors de la génération",
    generatingImage: "Génération en cours...",

    // Loading Steps
    loadingCreation: "Création en cours",
    loadingAI: "Notre IA génère vos designs sur mesure",
    loadingStep1: "Analyse de votre pierre précieuse",
    loadingStep2: "Génération du design principal (A)",
    loadingStep3: "Création des variations (B & C)",

    // Virtual Try-On
    virtualTryOn: "Essayage Virtuel",
    visualizeOnHand: "Visualisez votre bague sur votre main",
    yourHand: "VOTRE MAIN",
    yourRing: "VOTRE BAGUE",
    changePhoto: "Changer de photo",
    generateTryOn: "Générer l'essayage",
    tryOnTip: "Pour un meilleur résultat, prenez une photo de votre main avec les doigts écartés et sur un fond neutre.",
    result: "Résultat",
    uploadHandPhoto: "Uploadez une photo de votre main",

    // Metal (ConfigurePage)
    metalSectionTitle: "Métal",
    metalSectionSubtitle: "Choisissez votre métal précieux",
    yellowGold: "Or Jaune",
    whiteGold: "Or Blanc",
    roseGold: "Or Rose",
    platinum: "Platine",

    // Stone page
    preciousStoneLabel: "Pierre Précieuse",
    
    // Misc
    logoutSuccess: "Déconnexion réussie",
    loginRequired: "Connexion requise",
    upToChars: "Jusqu'à {max} caractères",
    accessDesigns: "Accédez à vos Designs",
    connectOrCreate: "Connectez-vous ou créez un compte pour voir vos créations",
    firstNameRequired: "Prénom requis",
    passwordRequired: "Mot de passe requis",
    passwordMinLength: "Minimum 6 caractères",
    firstName: "Prénom",
    lastName: "Nom",
    emailLabel: "Adresse e-mail",
    passwordLabel: "Mot de passe",
    yourPassword: "Votre mot de passe",
    phone: "Téléphone",

    // Product Detail Modal
    shape: "Forme",
    weight: "Poids",
    dimensions: "Dimensions",
    clarity: "Clarté",
    treatment: "Traitement",
    origin: "Origine",
    selectThisStone: "Sélectionner cette pierre",
    viewInShop: "Voir sur la boutique",

    // Engraving detail
    yourText: "Votre texte",
    fontStyle: "Style de police",
    classicFont: "Classique",
    elegantFont: "Élégant",
    cursiveFont: "Cursif",
    engravingPlaceholder: "ex: Pour toujours",
    engravingSample: "Pour toujours",
    upToMaxChars: "Jusqu'à {max} caractères",
    addEngravingToggle: "Gravure hinzufügen",
    confirmationTitle: "Magnifique !",
    confirmationMessage: "Nous avons hâte de commencer ce projet avec vous. Notre équipe vous enverra le devis correspondant dans les 48h. Il sera disponible dans votre messagerie personnelle.",
    goToMessages: "Accéder à ma messagerie",
    backToDesign: "Revenir au design",
    quoteInProgress: "Devis en cours",
    awaitingQuote: "En attente de devis",
    quoteRequested: "Demande de devis envoyée !",
    myQuotes: "Mes Devis",
    noQuotes: "Aucun devis",
    quotesWillAppear: "Vos devis apparaîtront ici une fois établis par notre équipe.",
    downloadPdf: "Télécharger le PDF",
    contactTab: "Contact",
    selectYourDesign: "Sélectionnez votre design",
    selectDesignDesc: "Choisissez un design de notre catalogue ou uploadez votre propre inspiration",
    personalization: "Personnalisation",
  },
  
  en_US: {
    // Intro Page
    welcome: "Welcome to",
    tagline: "Be the architect of your dream ring",
    taglineSubtitleLine1: "The world's first jewelry house to put creation in your hands:",
    taglineSubtitleLine2: "From selecting your stone to choosing the design, visualize your creation worn before its manufacture even begins in our workshops.",
    startDesigning: "Start Designing",
    discoverHouse: "Discover the House",
    signIn: "Sign In",
    signUp: "Sign Up",
    myCreations: "My Creations",
    myAccount: "My Account",
    logout: "Logout",
    
    // About Page Hero
    aboutHeroSubtitle: "The world's first jewelry house to put creation in your hands:",
    aboutHeroSubtitle2: "From selecting your stone to choosing the design, visualize your creation worn before its manufacture even begins in our workshops.",
    createYourRing: "Create your ring",
    
    // Creation Steps
    processLabel: "Process",
    creationStepsTitle: "The creation steps",
    step: "Step",
    stoneChoiceTitle: "Stone selection",
    stoneChoiceDesc: "Select the ideal stone from our wide range of sapphires, emeralds, rubies, tourmalines, garnets and many more. All our stones are certified by renowned laboratories. Thanks to our offices in India, Sri Lanka and Bangkok, at the heart of markets and mines, we have privileged access to the finest stones, in advance.",
    designTitle: "The design",
    designDesc: "Select the design that suits you or send us your inspiration photos. Choose the metal and customize every detail of your ring. And if the final design doesn't fully satisfy you, our designer can create a custom version, perfectly adapted to your desires and style.",
    manufacturingTitle: "Manufacturing",
    manufacturingDesc: "Your creation is handcrafted in our workshops in Thailand, Italy and France by our master craftsmen. Track the progress of your ring's manufacture directly through your personal space, from design to delivery.",
    
    // FAQ
    faqLabel: "FAQ",
    faqTitle: "Frequently asked questions",
    faq1Question: "How does custom creation work?",
    faq1Answer: "From your personal account, you access our discussion space, where you can exchange directly with our teams about your desires, your story and your budget. In this space, you can make all necessary modifications, whether it's the choice of stone or design, to create the ring of your dreams.\n\nOur experts will guide you in selecting the ideal stone for your project. If the generated design doesn't perfectly match your expectations, our designers can step in to offer fully personalized creations. Once all elements are validated, you will have access to your quote. Its validation triggers the creation of your ring by our master jewelers, handcrafted according to the highest standards of excellence of Maison Bonnot Paris.",
    faq2Question: "Are your stones certified?",
    faq2Answer: "Yes, all our stones are certified by renowned laboratories such as Bellerophon, ICA GemLab, London Gem Lab, and others, guaranteeing their authenticity and exceptional quality.",
    faq3Question: "How is my custom jewelry delivered?",
    faq3Answer: "Delivery is made in person in Paris or via a specialized carrier, to ensure secure, insured and fully reliable shipping to destination.",
    faq4Question: "What are the creation lead times?",
    faq4Answer: "The production time depends on the complexity of the jewelry, but generally takes between 4 and 8 weeks after quote validation.",
    faq5Question: "Can I reuse my gold for my creation?",
    faq5Answer: "We offer a recycling and transformation service for your jewelry. The gold from your existing pieces can be reused to give them new life, at the heart of a creation designed especially for you.\n\nIf you wish to create your jewelry from your own gold, we invite you to indicate this by clicking on the 'I want to reuse my gold for my ring' button in step 2, or directly via the discussion space accessible from your account.",
    faq6Question: "What if I can't travel to Paris?",
    faq6Answer: "We assist many clients throughout France and internationally. From your personal space, you can send us your questions and concerns at any time. Our teams remain at your disposal and accompany you with care throughout the creation process.",
    
    // Configure Page - Reuse Gold
    reuseGoldTitle: "Reuse your gold",
    reuseGoldSubtitle: "We only accept 18k 750 gold",
    reuseGoldToggle: "I want to reuse my gold for my ring",
    reuseGoldToggleDesc: "We will melt your gold to create your new ring",
    goldWeightLabel: "Weight of your gold (in grams)",
    goldWeightPlaceholder: "Ex: 15",
    goldWeightHelp: "If you don't know the exact weight, leave this field empty. We will determine it together.",
    
    // Configure Page - Metal
    metalTitle: "Metal",
    metalSubtitle: "Choose your precious metal",
    
    // Configure Page - Ring Size
    ringSizeTitle: "Ring size",
    ringSizeSubtitle: "Standard women's size: 53",
    ringSizeUnknown: "I don't know my size",
    
    // Configure Page - Budget
    budgetTitle: "Budget",
    budgetSubtitle: "Estimate for your project",
    
    // About Page
    aboutTitle: "Maison Bonnot Paris",
    aboutSubtitle: "Fine Jewelry since 1987",
    aboutDescription1: "For over 35 years, Maison Bonnot Paris has embodied the excellence of French fine jewelry. Our Parisian workshop perpetuates exceptional artisanal expertise, passed down through generations.",
    aboutDescription2: "Each creation is the result of a unique collaboration between our master jewelers and you. From selecting the precious stone to the final design, we guide you to bring the ring of your dreams to life.",
    aboutDescription3: "Thanks to our artificial intelligence technology, instantly visualize your ideas and explore personalized designs before entrusting them to our craftsmen.",
    ourValues: "Our Values",
    valueExcellence: "Excellence",
    valueExcellenceDesc: "Exceptional artisanal craftsmanship",
    valueCreativity: "Creativity",
    valueCreativityDesc: "Unique and personalized designs",
    valueQuality: "Quality",
    valueQualityDesc: "The finest precious stones",
    backToHome: "Back",
    readyToCreate: "Ready to create?",
    
    ourCatalog: "Our Catalogue", selectYourGemstone: "Select your gemstone", filters: "Filters", filterType: "Type", filterPrice: "Price", filterWeight: "Weight", filterShape: "Shape", filterClarity: "Clarity", filterTreatment: "Treatment", filterOrigin: "Origin", search: "Search", video: "Video", continueBtn: "Continue", backBtn: "Back",
    stepLabel: "STEP", preciousStone: "PRECIOUS STONE", configuration: "CONFIGURATION", personalizeCreation: "Personalize Your Creation", selectPreferences: "Select your preferences to create the perfect ring", chooseYourStone: "Choose Your Stone", yourChoices: "Your choices",
    engravingTitle: "Engraving", engravingSubtitle: "Add a personal message inside the ring", addEngraving: "Add an engraving", maxChars: "Up to 20 characters",
    dontKnowSize: "I don't know my size", budgetTitle: "Budget", budgetSubtitle: "Estimate for your project", andMore: "and more",
    reuseGoldTitle: "Reuse your gold", reuseGoldSubtitle: "We only accept 18k 750 gold", reuseGoldYes: "Yes, I'd like to reuse my gold",
    creationInProgress: "Creating", aiGenerating: "Our AI is generating your custom designs", analyzingStone: "Analyzing your gemstone", generatingMainDesign: "Generating main design (A)", creatingVariations: "Creating variations (B & C)", estimatedTime: "Estimated time", aboutSeconds: "about 1 to 2 minutes",
    uploadTitle: "Your Inspiration", uploadDesc: "Choose a Bonnot Paris design or upload your own inspiration.", copyrightWarning: "To avoid illegal reproduction of existing rings, we recommend using our Bonnot Paris inspirations or royalty-free images.", dropOrClick: "Drag your image or click to upload", pngJpgPdf: "PNG, JPG, PDF — 1 image maximum", maxOneUpload: "You can only upload one inspiration.", alreadyUploadedInsp: "You've already uploaded your inspiration. Remove it to choose another.",
    // Navigation
    upload: "Stone", design: "Design",
    configure: "Settings",
    designs: "Designs",
    results: "Your Creation",
    
    // Gemstone Page
    selectGemstone: "Select your gemstone",
    uploadYourStone: "Upload your stone",
    orChooseFromCatalog: "Or choose from our catalog",
    continue: "Continue",
    
    // Configuration Page
    selectMetal: "Choose your metal",
    yellowGold: "Yellow Gold",
    whiteGold: "White Gold",
    roseGold: "Rose Gold",
    platinum: "Platinum",
    selectInspiration: "Choose your inspirations",
    generateDesigns: "Generate designs",
    inspirationSelected: "1 inspiration selected",
    
    // Results Page
    yourDesigns: "Your Designs",
    selectVariation: "Select a variation",
    refine: "Refine",
    wornView: "Worn view",
    virtualTryOn: "Virtual try-on",
    requestQuote: "Request a quote",
    
    // Quote Page
    quoteRequest: "Quote request",
    selectedDesign: "Selected design",
    estimatedPrice: "Estimated price",
    contactInfo: "Contact information",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    message: "Message",
    submit: "Submit",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    
    // Language names
    langFrench: "French",
    langUSEnglish: "US English",
    langUKEnglish: "UK English",
    langGerman: "German",
    langSpanish: "Spanish",
    trustNoMiddleman: "No Middleman", trustNoMiddlemanDesc: "The only jewelry house with offices in Sri Lanka, India and Thailand", trustNaturalStone: "Natural Stone", trustNaturalStoneDesc: "Our unique gems reflect the purity and elegance of nature", trustCertificate: "Delivered with Certificate", trustCertificateDesc: "Exclusively by renowned independent laboratories", trustICA: "ICA Member", trustICADesc: "International Colored Gemstone Association", trustHandmade: "Handcrafted", trustHandmadeDesc: "Each piece handmade in 18k gold, reflecting our commitment to quality", trustExpertise: "Centuries of Expertise", trustExpertiseDesc: "Workshops with hundreds of years of experience", trustResize: "Free Resizing", trustResizeDesc: "Complimentary adjustment for perfect comfort",
    ourDesigns: "Our Designs", designsForShape: "design(s) for your stone shape", selectStoneForDesigns: "Select a stone to see matching designs", noDesignsForShape: "No designs available for this shape", selectStoneToSee: "Select a stone to see designs",
    yourInspiration: "Your Inspiration", addYourImage: "Add your own inspiration image (PNG, JPEG, PDF)", oneImage: "1 image", complete: "Complete", alreadyUploaded: "You've already uploaded your inspiration. Remove it to choose another.", dropImageHere: "Drop your image here", dragOrClick: "Drag your image or click to upload", oneImageMax: "PNG, JPG, PDF — 1 image maximum", chooseDesignOrUpload: "Choose a Bonnot Paris design or upload your own inspiration. AI will use this reference to create your ring.", copyrightNotice: "To avoid illegal reproduction of existing rings, we recommend using our Bonnot Paris inspirations or royalty-free images.",
    refineDesign: "Refine Design", selectModifications: "Select desired modifications", initialDesign: "Initial Design", bandStructure: "Band Structure", bandWithDiamonds: "Diamond-set Band", bandNoDiamonds: "Plain Band", removeAllPave: "Remove All Pavé", secondaryStones: "Secondary Stones", replaceColorWithDiamond: "Replace colored stones with diamonds", settingType: "Setting Type", prongsEagle: "Claw Prongs", prongsRound: "Round Prongs", bezelSetting: "Bezel Setting", metalType: "Metal", singleOptionOnly: "Single option only", modificationsSelected: "modification(s) selected", generateNewVersion: "Generate New Version", generationInProgress: "Generating...", selectAtLeastOne: "Select at least one modification",
    myRequests: "My Requests", myCreationsTab: "My Creations", messaging: "Messages", fabricationTracking: "Fabrication Tracking", faqHelp: "FAQ & Help", mySpace: "My Account", logout: "Log Out", noCreations: "No creations", creationsWillAppear: "Your generated designs will appear here.", noFabrication: "No projects in fabrication", fabricationWillAppear: "Once your quote is validated, you can track progress here", estimatedDelivery: "Estimated delivery", writeMessage: "Write your message...", messageSent: "Message sent", noMessages: "We will send your quote within 48 hours. Feel free to share all details about your creation.", bonnotTeam: "Bonnot Paris Team", contactByEmail: "Contact us by email",
    connection: "Sign In", accessCreations: "Access your creations", createAccount: "Create Account", saveDesigns: "Save your favorite designs", forgotPassword: "Forgot password?", forgotPasswordTitle: "Forgot Password", forgotPasswordDesc: "Enter your email to receive a reset link", newPassword: "New Password", newPasswordDesc: "Choose your new password", sendLink: "Send Link", resetPassword: "Reset Password", emailSent: "Email sent!", emailSentDesc: "If an account exists with this email, you will receive a link to reset your password.", backToLogin: "Back to sign in", noAccount: "No account yet?", alreadyAccount: "Already have an account?", connecting: "Signing in...", creating: "Creating...", sending: "Sending...", resetting: "Resetting...",
    personalizeDesign: "Personalize Your Design", seeWorn: "See Worn", wornViewsGenerated: "Worn views generated", generateWornViews: "Generate worn views", tryOnHand: "Try on My Hand", tryOnHandDesc: "Visualize with your photo", refineDesignBtn: "Refine Design", refineDesignDesc: "Modify details", validateDesign: "Validate This Design", designSaved: "This design will be saved in \"My Creations\"", tip: "Tip", tipSelection: "Click the design you like most to customize it.", tipCustomization: "Use the options to see the design worn or refine it before validating.",
    stoneValidation: "Stone Validation", designValidation: "Design Validation", quoteValidation: "Quote Validation", depositPayment: "Deposit Payment", waxCreation: "Wax Model Creation", workshopFabrication: "Workshop Fabrication", photoShooting: "Ring Photo Shoot", shippingDelivery: "Shipping / Hand Delivery", finalPayment: "Final Payment", delivered: "Delivered",
    stoneLabel: "Stone", designLabel: "Design", designChosen: "Selected", yourDesignLabel: "Your design", notChosen: "Not chosen", metalLabel: "Metal", sizeLabel: "Size", sizeNotChosen: "Not chosen", budgetLabel: "Budget", budgetDefined: "Set", budgetNotDefined: "Not set", generate: "Generate", generating: "Generating...",
    selectMatchingDesign: "Select the design that suits you", adjustDesign: "Adjust the design to your taste", chooseYourStyle: "Choose Your Style", chooseStyleDesc: "Select the design you like most, then adapt it to your taste and style.", clickToCustomize: "Click a design to customize it", optionsTitle: "Customization options", seeWornBtn: "See Worn", wornGenerated: "Worn views generated", generateWorn: "Generate worn views", tryOnBtn: "Try on my hand", tryOnDesc: "Visualize with your photo", refineBtn: "Refine design", refineDesc: "Modify details", validateBtn: "Request my free quote", savedInCreations: "This design will be saved in \"My Creations\"", tipLabel: "Tip", tipClickDesign: "Click the design you like most to customize it.", designRefined: "Design refined! Worn views have been reset.", selectOneMod: "Select at least one modification", personalizeYourDesign: "Personalize your design", generationSuccess: "Generation successful!", generationError: "Error during generation", generatingImage: "Generating...",
    loadingCreation: "Creating", loadingAI: "Our AI is generating your custom designs", loadingStep1: "Analyzing your gemstone", loadingStep2: "Generating main design (A)", loadingStep3: "Creating variations (B & C)",
    virtualTryOn: "Virtual Try-On", visualizeOnHand: "Visualize your ring on your hand", yourHand: "YOUR HAND", yourRing: "YOUR RING", changePhoto: "Change photo", generateTryOn: "Generate try-on", tryOnTip: "For best results, take a photo of your hand with fingers spread on a neutral background.", result: "Result", uploadHandPhoto: "Upload a photo of your hand",
    metalSectionTitle: "Metal", metalSectionSubtitle: "Choose your precious metal", preciousStoneLabel: "Precious Stone",
    logoutSuccess: "Logged out successfully", loginRequired: "Login required", upToChars: "Up to {max} characters",
    accessDesigns: "Access your Designs", connectOrCreate: "Sign in or create an account to see your creations", firstNameRequired: "First name required", passwordRequired: "Password required", passwordMinLength: "Minimum 6 characters", firstName: "First name", lastName: "Last name", emailLabel: "Email address", passwordLabel: "Password", yourPassword: "Your password", phone: "Phone",
    shape: "Shape", weight: "Weight", dimensions: "Dimensions", clarity: "Clarity", treatment: "Treatment", origin: "Origin", selectThisStone: "Select this stone", viewInShop: "View in shop",
    yourText: "Your text", fontStyle: "Font style", classicFont: "Classic", elegantFont: "Elegant", cursiveFont: "Cursive", engravingPlaceholder: "e.g.: Forever", engravingSample: "Forever", upToMaxChars: "Up to {max} characters",
    confirmationTitle: "Wonderful!", confirmationMessage: "We can't wait to start this project with you. Our team will send you the corresponding quote within 48 hours. It will be available in your personal messages.", goToMessages: "Go to my messages", backToDesign: "Back to design",
  },
  
  en_GB: {
    // Intro Page
    welcome: "Welcome to",
    tagline: "Be the architect of your dream ring",
    taglineSubtitleLine1: "The world's first jewellery house to put creation in your hands:",
    taglineSubtitleLine2: "From selecting your stone to choosing the design, visualise your creation worn before its manufacture even begins in our workshops.",
    startDesigning: "Start Designing",
    discoverHouse: "Discover the House",
    signIn: "Sign In",
    signUp: "Sign Up",
    myCreations: "My Creations",
    myAccount: "My Account",
    logout: "Logout",
    
    // About Page Hero
    aboutHeroSubtitle: "The world's first jewellery house to put creation in your hands:",
    aboutHeroSubtitle2: "From selecting your stone to choosing the design, visualise your creation worn before its manufacture even begins in our workshops.",
    createYourRing: "Create your ring",
    
    // Creation Steps
    processLabel: "Process",
    creationStepsTitle: "The creation steps",
    step: "Step",
    stoneChoiceTitle: "Stone selection",
    stoneChoiceDesc: "Select the ideal stone from our wide range of sapphires, emeralds, rubies, tourmalines, garnets and many more. All our stones are certified by renowned laboratories. Thanks to our offices in India, Sri Lanka and Bangkok, at the heart of markets and mines, we have privileged access to the finest stones, in advance.",
    designTitle: "The design",
    designDesc: "Select the design that suits you or send us your inspiration photos. Choose the metal and customise every detail of your ring. And if the final design doesn't fully satisfy you, our designer can create a bespoke version, perfectly adapted to your desires and style.",
    manufacturingTitle: "Manufacturing",
    manufacturingDesc: "Your creation is handcrafted in our workshops in Thailand, Italy and France by our master craftsmen. Track the progress of your ring's manufacture directly through your personal space, from design to delivery.",
    
    // FAQ
    faqLabel: "FAQ",
    faqTitle: "Frequently asked questions",
    faq1Question: "How does bespoke creation work?",
    faq1Answer: "From your personal account, you access our discussion space, where you can exchange directly with our teams about your desires, your story and your budget. In this space, you can make all necessary modifications, whether it's the choice of stone or design, to create the ring of your dreams.\n\nOur experts will guide you in selecting the ideal stone for your project. If the generated design doesn't perfectly match your expectations, our designers can step in to offer fully personalised creations. Once all elements are validated, you will have access to your quote. Its validation triggers the creation of your ring by our master jewellers, handcrafted according to the highest standards of excellence of Maison Bonnot Paris.",
    faq2Question: "Are your stones certified?",
    faq2Answer: "Yes, all our stones are certified by renowned laboratories such as Bellerophon, ICA GemLab, London Gem Lab, and others, guaranteeing their authenticity and exceptional quality.",
    faq3Question: "How is my bespoke jewellery delivered?",
    faq3Answer: "Delivery is made in person in Paris or via a specialised carrier, to ensure secure, insured and fully reliable shipping to destination.",
    faq4Question: "What are the creation lead times?",
    faq4Answer: "The production time depends on the complexity of the jewellery, but generally takes between 4 and 8 weeks after quote validation.",
    faq5Question: "Can I reuse my gold for my creation?",
    faq5Answer: "We offer a recycling and transformation service for your jewellery. The gold from your existing pieces can be reused to give them new life, at the heart of a creation designed especially for you.\n\nIf you wish to create your jewellery from your own gold, we invite you to indicate this by clicking on the 'I want to reuse my gold for my ring' button in step 2, or directly via the discussion space accessible from your account.",
    faq6Question: "What if I can't travel to Paris?",
    faq6Answer: "We assist many clients throughout France and internationally. From your personal space, you can send us your questions and concerns at any time. Our teams remain at your disposal and accompany you with care throughout the creation process.",
    
    // Configure Page - Reuse Gold
    reuseGoldTitle: "Reuse your gold",
    reuseGoldSubtitle: "We only accept 18k 750 gold",
    reuseGoldToggle: "I want to reuse my gold for my ring",
    reuseGoldToggleDesc: "We will melt your gold to create your new ring",
    goldWeightLabel: "Weight of your gold (in grams)",
    goldWeightPlaceholder: "Ex: 15",
    goldWeightHelp: "If you don't know the exact weight, leave this field empty. We will determine it together.",
    
    // Configure Page - Metal
    metalTitle: "Metal",
    metalSubtitle: "Choose your precious metal",
    
    // Configure Page - Ring Size
    ringSizeTitle: "Ring size",
    ringSizeSubtitle: "Standard women's size: 53",
    ringSizeUnknown: "I don't know my size",
    
    // Configure Page - Budget
    budgetTitle: "Budget",
    budgetSubtitle: "Estimate for your project",
    
    // About Page
    aboutTitle: "Maison Bonnot Paris",
    aboutSubtitle: "Fine Jewellery since 1987",
    aboutDescription1: "For over 35 years, Maison Bonnot Paris has embodied the excellence of French fine jewellery. Our Parisian workshop perpetuates exceptional artisanal expertise, passed down through generations.",
    aboutDescription2: "Each creation is the result of a unique collaboration between our master jewellers and you. From selecting the precious stone to the final design, we guide you to bring the ring of your dreams to life.",
    aboutDescription3: "Thanks to our artificial intelligence technology, instantly visualise your ideas and explore personalised designs before entrusting them to our craftsmen.",
    ourValues: "Our Values",
    valueExcellence: "Excellence",
    valueExcellenceDesc: "Exceptional artisanal craftsmanship",
    valueCreativity: "Creativity",
    valueCreativityDesc: "Unique and personalised designs",
    valueQuality: "Quality",
    valueQualityDesc: "The finest precious stones",
    backToHome: "Back",
    readyToCreate: "Ready to create?",
    
    ourCatalog: "Our Catalogue", selectYourGemstone: "Select your gemstone", filters: "Filters", filterType: "Type", filterPrice: "Price", filterWeight: "Weight", filterShape: "Shape", filterClarity: "Clarity", filterTreatment: "Treatment", filterOrigin: "Origin", search: "Search", video: "Video", continueBtn: "Continue", backBtn: "Back",
    stepLabel: "STEP", preciousStone: "PRECIOUS STONE", configuration: "CONFIGURATION", personalizeCreation: "Personalise Your Creation", selectPreferences: "Select your preferences to create the perfect ring", chooseYourStone: "Choose Your Stone", yourChoices: "Your choices",
    engravingTitle: "Engraving", engravingSubtitle: "Add a personal message inside the ring", addEngraving: "Add an engraving", maxChars: "Up to 20 characters",
    dontKnowSize: "I don't know my size", budgetTitle: "Budget", budgetSubtitle: "Estimate for your project", andMore: "and more",
    reuseGoldTitle: "Reuse your gold", reuseGoldSubtitle: "We only accept 18k 750 gold", reuseGoldYes: "Yes, I'd like to reuse my gold",
    creationInProgress: "Creating", aiGenerating: "Our AI is generating your custom designs", analyzingStone: "Analysing your gemstone", generatingMainDesign: "Generating main design (A)", creatingVariations: "Creating variations (B & C)", estimatedTime: "Estimated time", aboutSeconds: "about 1 to 2 minutes",
    uploadTitle: "Your Inspiration", uploadDesc: "Choose a Bonnot Paris design or upload your own inspiration.", copyrightWarning: "To avoid illegal reproduction of existing rings, we recommend using our Bonnot Paris inspirations or royalty-free images.", dropOrClick: "Drag your image or click to upload", pngJpgPdf: "PNG, JPG, PDF — 1 image maximum", maxOneUpload: "You can only upload one inspiration.", alreadyUploadedInsp: "You've already uploaded your inspiration. Remove it to choose another.",
    // Navigation
    upload: "Stone", design: "Design",
    configure: "Settings",
    designs: "Designs",
    results: "Your Creation",
    
    // Gemstone Page
    selectGemstone: "Select your gemstone",
    uploadYourStone: "Upload your stone",
    orChooseFromCatalog: "Or choose from our catalogue",
    continue: "Continue",
    
    // Configuration Page
    selectMetal: "Choose your metal",
    yellowGold: "Yellow Gold",
    whiteGold: "White Gold",
    roseGold: "Rose Gold",
    platinum: "Platinum",
    selectInspiration: "Choose your inspirations",
    generateDesigns: "Generate designs",
    inspirationSelected: "1 inspiration selected",
    
    // Results Page
    yourDesigns: "Your Designs",
    selectVariation: "Select a variation",
    refine: "Refine",
    wornView: "Worn view",
    virtualTryOn: "Virtual try-on",
    requestQuote: "Request a quote",
    
    // Quote Page
    quoteRequest: "Quote request",
    selectedDesign: "Selected design",
    estimatedPrice: "Estimated price",
    contactInfo: "Contact information",
    firstName: "First name",
    lastName: "Surname",
    email: "Email",
    phone: "Phone",
    message: "Message",
    submit: "Submit",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    
    // Language names
    langFrench: "French",
    langUSEnglish: "US English",
    langUKEnglish: "UK English",
    langGerman: "German",
    langSpanish: "Spanish",
    trustNoMiddleman: "No Middleman", trustNoMiddlemanDesc: "The only jewelry house with offices in Sri Lanka, India and Thailand", trustNaturalStone: "Natural Stone", trustNaturalStoneDesc: "Our unique gems reflect the purity and elegance of nature", trustCertificate: "Delivered with Certificate", trustCertificateDesc: "Exclusively by renowned independent laboratories", trustICA: "ICA Member", trustICADesc: "International Colored Gemstone Association", trustHandmade: "Handcrafted", trustHandmadeDesc: "Each piece handmade in 18ct gold, reflecting our commitment to quality", trustExpertise: "Centuries of Expertise", trustExpertiseDesc: "Workshops with hundreds of years of experience", trustResize: "Free Resizing", trustResizeDesc: "Complimentary adjustment for perfect comfort",
    ourDesigns: "Our Designs", designsForShape: "design(s) for your stone shape", selectStoneForDesigns: "Select a stone to see matching designs", noDesignsForShape: "No designs available for this shape", selectStoneToSee: "Select a stone to see designs",
    yourInspiration: "Your Inspiration", addYourImage: "Add your own inspiration image (PNG, JPEG, PDF)", oneImage: "1 image", complete: "Complete", alreadyUploaded: "You've already uploaded your inspiration. Remove it to choose another.", dropImageHere: "Drop your image here", dragOrClick: "Drag your image or click to upload", oneImageMax: "PNG, JPG, PDF — 1 image maximum", chooseDesignOrUpload: "Choose a Bonnot Paris design or upload your own inspiration. AI will use this reference to create your ring.", copyrightNotice: "To avoid illegal reproduction of existing rings, we recommend using our Bonnot Paris inspirations or royalty-free images.",
    refineDesign: "Refine Design", selectModifications: "Select desired modifications", initialDesign: "Initial Design", bandStructure: "Band Structure", bandWithDiamonds: "Diamond-set Band", bandNoDiamonds: "Plain Band", removeAllPave: "Remove All Pavé", secondaryStones: "Secondary Stones", replaceColorWithDiamond: "Replace coloured stones with diamonds", settingType: "Setting Type", prongsEagle: "Claw Prongs", prongsRound: "Round Prongs", bezelSetting: "Bezel Setting", metalType: "Metal", singleOptionOnly: "Single option only", modificationsSelected: "modification(s) selected", generateNewVersion: "Generate New Version", generationInProgress: "Generating...", selectAtLeastOne: "Select at least one modification",
    myRequests: "My Requests", myCreationsTab: "My Creations", messaging: "Messages", fabricationTracking: "Fabrication Tracking", faqHelp: "FAQ & Help", mySpace: "My Account", logout: "Log Out", noCreations: "No creations", creationsWillAppear: "Your generated designs will appear here.", noFabrication: "No projects in fabrication", fabricationWillAppear: "Once your quote is validated, you can track progress here", estimatedDelivery: "Estimated delivery", writeMessage: "Write your message...", messageSent: "Message sent", noMessages: "We will send your quote within 48 hours. Feel free to share all details about your creation.", bonnotTeam: "Bonnot Paris Team", contactByEmail: "Contact us by email",
    connection: "Sign In", accessCreations: "Access your creations", createAccount: "Create Account", saveDesigns: "Save your favourite designs", forgotPassword: "Forgot password?", forgotPasswordTitle: "Forgot Password", forgotPasswordDesc: "Enter your email to receive a reset link", newPassword: "New Password", newPasswordDesc: "Choose your new password", sendLink: "Send Link", resetPassword: "Reset Password", emailSent: "Email sent!", emailSentDesc: "If an account exists with this email, you will receive a link to reset your password.", backToLogin: "Back to sign in", noAccount: "No account yet?", alreadyAccount: "Already have an account?", connecting: "Signing in...", creating: "Creating...", sending: "Sending...", resetting: "Resetting...",
    personalizeDesign: "Personalise Your Design", seeWorn: "See Worn", wornViewsGenerated: "Worn views generated", generateWornViews: "Generate worn views", tryOnHand: "Try on My Hand", tryOnHandDesc: "Visualise with your photo", refineDesignBtn: "Refine Design", refineDesignDesc: "Modify details", validateDesign: "Validate This Design", designSaved: "This design will be saved in \"My Creations\"", tip: "Tip", tipSelection: "Click the design you like most to customise it.", tipCustomization: "Use the options to see the design worn or refine it before validating.",
    stoneValidation: "Stone Validation", designValidation: "Design Validation", quoteValidation: "Quote Validation", depositPayment: "Deposit Payment", waxCreation: "Wax Model Creation", workshopFabrication: "Workshop Fabrication", photoShooting: "Ring Photo Shoot", shippingDelivery: "Shipping / Hand Delivery", finalPayment: "Final Payment", delivered: "Delivered",
    stoneLabel: "Stone", designLabel: "Design", designChosen: "Selected", yourDesignLabel: "Your design", notChosen: "Not chosen", metalLabel: "Metal", sizeLabel: "Size", sizeNotChosen: "Not chosen", budgetLabel: "Budget", budgetDefined: "Set", budgetNotDefined: "Not set", generate: "Generate", generating: "Generating...",
    selectMatchingDesign: "Select the design that suits you", adjustDesign: "Adjust the design to your taste", chooseYourStyle: "Choose Your Style", chooseStyleDesc: "Select the design you like most, then adapt it to your taste and style.", clickToCustomize: "Click a design to customise it", optionsTitle: "Customisation options", seeWornBtn: "See Worn", wornGenerated: "Worn views generated", generateWorn: "Generate worn views", tryOnBtn: "Try on my hand", tryOnDesc: "Visualise with your photo", refineBtn: "Refine design", refineDesc: "Modify details", validateBtn: "Request my free quote", savedInCreations: "This design will be saved in \"My Creations\"", tipLabel: "Tip", tipClickDesign: "Click the design you like most to customise it.", designRefined: "Design refined! Worn views have been reset.", selectOneMod: "Select at least one modification", personalizeYourDesign: "Personalise your design", generationSuccess: "Generation successful!", generationError: "Error during generation", generatingImage: "Generating...",
    loadingCreation: "Creating", loadingAI: "Our AI is generating your custom designs", loadingStep1: "Analysing your gemstone", loadingStep2: "Generating main design (A)", loadingStep3: "Creating variations (B & C)",
    virtualTryOn: "Virtual Try-On", visualizeOnHand: "Visualise your ring on your hand", yourHand: "YOUR HAND", yourRing: "YOUR RING", changePhoto: "Change photo", generateTryOn: "Generate try-on", tryOnTip: "For best results, take a photo of your hand with fingers spread on a neutral background.", result: "Result", uploadHandPhoto: "Upload a photo of your hand",
    metalSectionTitle: "Metal", metalSectionSubtitle: "Choose your precious metal", preciousStoneLabel: "Precious Stone",
    logoutSuccess: "Logged out successfully", loginRequired: "Login required", upToChars: "Up to {max} characters",
    accessDesigns: "Access your Designs", connectOrCreate: "Sign in or create an account to see your creations", firstNameRequired: "First name required", passwordRequired: "Password required", passwordMinLength: "Minimum 6 characters", firstName: "First name", lastName: "Last name", emailLabel: "Email address", passwordLabel: "Password", yourPassword: "Your password", phone: "Phone",
    shape: "Shape", weight: "Weight", dimensions: "Dimensions", clarity: "Clarity", treatment: "Treatment", origin: "Origin", selectThisStone: "Select this stone", viewInShop: "View in shop",
    yourText: "Your text", fontStyle: "Font style", classicFont: "Classic", elegantFont: "Elegant", cursiveFont: "Cursive", engravingPlaceholder: "e.g.: Forever", engravingSample: "Forever", upToMaxChars: "Up to {max} characters",
    confirmationTitle: "Wonderful!", confirmationMessage: "We can't wait to start this project with you. Our team will send you the corresponding quote within 48 hours. It will be available in your personal messages.", goToMessages: "Go to my messages", backToDesign: "Back to design",
  },
  
  de: {
    // Intro Page
    welcome: "Willkommen bei",
    tagline: "Seien Sie der Architekt Ihres Traumrings",
    taglineSubtitleLine1: "Das erste Juwelierhaus der Welt, das die Kreation in Ihre Hände legt:",
    taglineSubtitleLine2: "Von der Auswahl Ihres Steins bis zur Wahl des Designs – visualisieren Sie Ihre Kreation getragen, noch bevor sie in unseren Werkstätten gefertigt wird.",
    startDesigning: "Design starten",
    discoverHouse: "Das Haus entdecken",
    signIn: "Anmelden",
    signUp: "Registrieren",
    myCreations: "Meine Kreationen",
    myAccount: "Mein Bereich",
    logout: "Abmelden",
    
    // About Page Hero
    aboutHeroSubtitle: "Das erste Juwelierhaus der Welt, das die Kreation in Ihre Hände legt:",
    aboutHeroSubtitle2: "Von der Auswahl Ihres Steins bis zur Wahl des Designs – visualisieren Sie Ihre Kreation getragen, noch bevor sie in unseren Werkstätten gefertigt wird.",
    createYourRing: "Ihren Ring erstellen",
    
    // Creation Steps
    processLabel: "Prozess",
    creationStepsTitle: "Die Kreationsschritte",
    step: "Schritt",
    stoneChoiceTitle: "Die Steinauswahl",
    stoneChoiceDesc: "Wählen Sie den idealen Stein aus unserer breiten Palette an Saphiren, Smaragden, Rubinen, Turmalinen, Granaten und vielen mehr. Alle unsere Steine sind von renommierten Laboren zertifiziert. Dank unserer Büros in Indien, Sri Lanka und Bangkok, im Herzen der Märkte und Minen, haben wir privilegierten Zugang zu den schönsten Steinen.",
    designTitle: "Das Design",
    designDesc: "Wählen Sie das Design, das zu Ihnen passt, oder senden Sie uns Ihre Inspirationsfotos. Wählen Sie das Metall und personalisieren Sie jedes Detail Ihres Rings. Und wenn das endgültige Design Sie nicht vollständig zufriedenstellt, kann unser Designer eine maßgeschneiderte Version erstellen, perfekt angepasst an Ihre Wünsche und Ihren Stil.",
    manufacturingTitle: "Die Fertigung",
    manufacturingDesc: "Ihre Kreation wird von Hand in unseren Werkstätten in Thailand, Italien und Frankreich von unseren Meisterhandwerkern gefertigt. Verfolgen Sie den Fortschritt der Fertigung Ihres Rings direkt über Ihren persönlichen Bereich, vom Design bis zur Lieferung.",
    
    // FAQ
    faqLabel: "FAQ",
    faqTitle: "Häufig gestellte Fragen",
    faq1Question: "Wie funktioniert die Maßanfertigung?",
    faq1Answer: "Von Ihrem persönlichen Konto aus haben Sie Zugang zu unserem Diskussionsbereich, wo Sie sich direkt mit unseren Teams über Ihre Wünsche, Ihre Geschichte und Ihr Budget austauschen können. In diesem Bereich können Sie alle notwendigen Änderungen vornehmen, sei es bei der Wahl des Steins oder des Designs, um den Ring Ihrer Träume zu kreieren.\n\nUnsere Experten werden Sie bei der Auswahl des idealen Steins für Ihr Projekt begleiten. Wenn das generierte Design nicht perfekt Ihren Erwartungen entspricht, können unsere Designer eingreifen, um vollständig personalisierte Kreationen anzubieten. Sobald alle Elemente validiert sind, haben Sie Zugang zu Ihrem Angebot. Seine Validierung löst die Realisierung Ihres Rings durch unsere Meisterjuweliere aus.",
    faq2Question: "Sind Ihre Steine zertifiziert?",
    faq2Answer: "Ja, alle unsere Steine sind von renommierten Laboren wie Bellerophon, ICA GemLab, London Gem Lab und anderen zertifiziert, was ihre Authentizität und außergewöhnliche Qualität garantiert.",
    faq3Question: "Wie wird mein Maßschmuck geliefert?",
    faq3Answer: "Die Lieferung erfolgt persönlich in Paris oder über einen spezialisierten Transporteur, um einen sicheren, versicherten und vollständig zuverlässigen Versand an den Bestimmungsort zu gewährleisten.",
    faq4Question: "Wie lange dauert die Erstellung?",
    faq4Answer: "Die Produktionszeit hängt von der Komplexität des Schmucks ab, beträgt aber in der Regel zwischen 4 und 8 Wochen nach der Angebotsvalidierung.",
    faq5Question: "Kann ich mein Gold für meine Kreation wiederverwenden?",
    faq5Answer: "Wir bieten einen Recycling- und Transformationsservice für Ihren Schmuck an. Das Gold Ihrer bestehenden Stücke kann wiederverwendet werden, um ihnen neues Leben einzuhauchen, im Herzen einer speziell für Sie entworfenen Kreation.\n\nWenn Sie Ihren Schmuck aus Ihrem eigenen Gold kreieren möchten, laden wir Sie ein, dies durch Klicken auf die Schaltfläche 'Ich möchte mein Gold für meinen Ring wiederverwenden' in Schritt 2 anzugeben, oder direkt über den Diskussionsbereich, der von Ihrem Konto aus zugänglich ist.",
    faq6Question: "Was ist, wenn ich nicht nach Paris reisen kann?",
    faq6Answer: "Wir begleiten viele Kunden in ganz Frankreich und international. Von Ihrem persönlichen Bereich aus können Sie uns jederzeit Ihre Fragen und Bedenken mitteilen. Unsere Teams bleiben zu Ihrer Verfügung und begleiten Sie mit Sorgfalt während des gesamten Kreationsprozesses.",
    
    // Configure Page - Reuse Gold
    reuseGoldTitle: "Ihr Gold wiederverwenden",
    reuseGoldSubtitle: "Wir akzeptieren nur 18k 750 Gold",
    reuseGoldToggle: "Ich möchte mein Gold für meinen Ring wiederverwenden",
    reuseGoldToggleDesc: "Wir werden Ihr Gold schmelzen, um Ihren neuen Ring zu erstellen",
    goldWeightLabel: "Gewicht Ihres Goldes (in Gramm)",
    goldWeightPlaceholder: "Z.B.: 15",
    goldWeightHelp: "Wenn Sie das genaue Gewicht nicht kennen, lassen Sie dieses Feld leer. Wir werden es gemeinsam bestimmen.",
    
    // Configure Page - Metal
    metalTitle: "Metall",
    metalSubtitle: "Wählen Sie Ihr Edelmetall",
    
    // Configure Page - Ring Size
    ringSizeTitle: "Ringgröße",
    ringSizeSubtitle: "Standardgröße Damen: 53",
    ringSizeUnknown: "Ich kenne meine Größe nicht",
    
    // Configure Page - Budget
    budgetTitle: "Budget",
    budgetSubtitle: "Schätzung für Ihr Projekt",
    
    // About Page
    aboutTitle: "Maison Bonnot Paris",
    aboutSubtitle: "Feine Juwelierkunst seit 1987",
    aboutDescription1: "Seit über 35 Jahren verkörpert Maison Bonnot Paris die Exzellenz französischer Haute Joaillerie. Unsere Pariser Werkstatt pflegt außergewöhnliches handwerkliches Know-how, das von Generation zu Generation weitergegeben wird.",
    aboutDescription2: "Jede Kreation ist das Ergebnis einer einzigartigen Zusammenarbeit zwischen unseren Meisterjuwelieren und Ihnen. Von der Auswahl des Edelsteins bis zum finalen Design begleiten wir Sie, um den Ring Ihrer Träume zum Leben zu erwecken.",
    aboutDescription3: "Dank unserer Technologie der künstlichen Intelligenz können Sie Ihre Ideen sofort visualisieren und personalisierte Designs erkunden, bevor Sie sie unseren Handwerkern anvertrauen.",
    ourValues: "Unsere Werte",
    valueExcellence: "Exzellenz",
    valueExcellenceDesc: "Außergewöhnliche Handwerkskunst",
    valueCreativity: "Kreativität",
    valueCreativityDesc: "Einzigartige und personalisierte Designs",
    valueQuality: "Qualität",
    valueQualityDesc: "Die schönsten Edelsteine",
    backToHome: "Zurück",
    readyToCreate: "Bereit zu kreieren?",
    
    // Navigation
    gemstone: "Edelstein",
    upload: "Stein", design: "Design", configure: "Einstellungen",
    designs: "Designs",
    quote: "Angebot",
    
    // Gemstone Page
    selectGemstone: "Wählen Sie Ihren Edelstein",
    uploadYourStone: "Laden Sie Ihren Stein hoch",
    orChooseFromCatalog: "Oder wählen Sie aus unserem Katalog",
    continue: "Weiter",
    
    // Configuration Page
    selectMetal: "Wählen Sie Ihr Metall",
    yellowGold: "Gelbgold",
    whiteGold: "Weißgold",
    roseGold: "Roségold",
    platinum: "Platin",
    selectInspiration: "Wählen Sie Ihre Inspirationen",
    generateDesigns: "Designs generieren",
    inspirationSelected: "1 Inspiration ausgewählt",
    
    // Results Page
    yourDesigns: "Ihre Designs",
    selectVariation: "Wählen Sie eine Variante",
    refine: "Verfeinern",
    wornView: "Trageansicht",
    virtualTryOn: "Virtuelle Anprobe",
    requestQuote: "Angebot anfordern",
    
    // Quote Page
    quoteRequest: "Angebotsanfrage",
    selectedDesign: "Ausgewähltes Design",
    estimatedPrice: "Geschätzter Preis",
    contactInfo: "Kontaktinformationen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    message: "Nachricht",
    submit: "Absenden",
    
    // Common
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    back: "Zurück",
    next: "Weiter",
    
    // Language names
    langFrench: "Französisch",
    langUSEnglish: "US-Englisch",
    langUKEnglish: "UK-Englisch",
    langGerman: "Deutsch",
    langSpanish: "Spanisch",
    ourCatalog: "Unser Katalog", selectYourGemstone: "Wählen Sie Ihren Edelstein", filters: "Filter", filterType: "Typ", filterPrice: "Preis", filterWeight: "Gewicht", filterShape: "Form", filterClarity: "Reinheit", filterTreatment: "Behandlung", filterOrigin: "Herkunft", search: "Suchen", video: "Video", continueBtn: "Weiter", backBtn: "Zurück",
    stepLabel: "SCHRITT", preciousStone: "EDELSTEIN", configuration: "KONFIGURATION", personalizeCreation: "Personalisieren Sie Ihre Kreation", selectPreferences: "Wählen Sie Ihre Präferenzen für den perfekten Ring", chooseYourStone: "Wählen Sie Ihren Stein", yourChoices: "Ihre Auswahl",
    engravingTitle: "Gravur", engravingSubtitle: "Fügen Sie eine persönliche Nachricht in den Ring ein", addEngraving: "Gravur hinzufügen", maxChars: "Bis zu 20 Zeichen",
    dontKnowSize: "Ich kenne meine Größe nicht", budgetTitle: "Budget", budgetSubtitle: "Schätzung für Ihr Projekt", andMore: "und mehr",
    reuseGoldTitle: "Ihr Gold wiederverwenden", reuseGoldSubtitle: "Wir akzeptieren nur 18k 750 Gold", reuseGoldYes: "Ja, ich möchte mein Gold wiederverwenden",
    creationInProgress: "Kreation läuft", aiGenerating: "Unsere KI erstellt Ihre maßgeschneiderten Designs", analyzingStone: "Analyse Ihres Edelsteins", generatingMainDesign: "Hauptdesign wird generiert (A)", creatingVariations: "Variationen werden erstellt (B & C)", estimatedTime: "Geschätzte Zeit", aboutSeconds: "etwa 1 bis 2 Minuten",
    uploadTitle: "Ihre Inspiration", uploadDesc: "Wählen Sie ein Bonnot Paris Design oder laden Sie Ihre eigene Inspiration hoch.", copyrightWarning: "Um illegale Reproduktion bestehender Ringe zu vermeiden, empfehlen wir unsere Bonnot Paris Inspirationen oder lizenzfreie Bilder.", dropOrClick: "Bild ziehen oder klicken zum Hochladen", pngJpgPdf: "PNG, JPG, PDF — max. 1 Bild", maxOneUpload: "Sie können nur eine Inspiration hochladen.", alreadyUploadedInsp: "Sie haben bereits Ihre Inspiration hochgeladen. Entfernen Sie sie, um eine andere auszuwählen.",
    trustNoMiddleman: "Ohne Zwischenhändler", trustNoMiddlemanDesc: "Das einzige Juwelierhaus mit Büros in Sri Lanka, Indien und Thailand", trustNaturalStone: "Naturstein", trustNaturalStoneDesc: "Unsere einzigartigen Edelsteine spiegeln die Reinheit und Eleganz der Natur", trustCertificate: "Mit Zertifikat geliefert", trustCertificateDesc: "Ausschließlich von renommierten unabhängigen Laboren", trustICA: "ICA-Mitglied", trustICADesc: "International Colored Gemstone Association", trustHandmade: "Handgefertigt", trustHandmadeDesc: "Jedes Schmuckstück aus 18 Karat Gold, ein Zeichen unserer Qualität", trustExpertise: "Jahrhundertealtes Handwerk", trustExpertiseDesc: "Werkstätten mit hunderten Jahren Erfahrung", trustResize: "Kostenlose Größenanpassung", trustResizeDesc: "Kostenlose Anpassung für perfekten Komfort",
    ourDesigns: "Unsere Designs", designsForShape: "Design(s) für Ihre Steinform", selectStoneForDesigns: "Wählen Sie einen Stein, um passende Designs zu sehen", noDesignsForShape: "Keine Designs für diese Form verfügbar", selectStoneToSee: "Wählen Sie einen Stein, um Designs zu sehen",
    yourInspiration: "Ihre Inspiration", addYourImage: "Fügen Sie Ihr eigenes Inspirationsbild hinzu (PNG, JPEG, PDF)", oneImage: "1 Bild", complete: "Vollständig", alreadyUploaded: "Sie haben bereits Ihre Inspiration hochgeladen. Entfernen Sie sie, um eine andere auszuwählen.", dropImageHere: "Bild hier ablegen", dragOrClick: "Bild ziehen oder klicken zum Hochladen", oneImageMax: "PNG, JPG, PDF — max. 1 Bild", chooseDesignOrUpload: "Wählen Sie ein Bonnot Paris Design oder laden Sie Ihre eigene Inspiration hoch.", copyrightNotice: "Um illegale Reproduktionen bestehender Ringe zu vermeiden, empfehlen wir unsere Bonnot Paris Inspirationen oder lizenzfreie Bilder.",
    refineDesign: "Design verfeinern", selectModifications: "Gewünschte Änderungen auswählen", initialDesign: "Ursprüngliches Design", bandStructure: "Ringstruktur", bandWithDiamonds: "Diamantbesetzter Ring", bandNoDiamonds: "Glatter Ring", removeAllPave: "Alle Pavé entfernen", secondaryStones: "Nebensteine", replaceColorWithDiamond: "Farbsteine durch Diamanten ersetzen", settingType: "Fassungsart", prongsEagle: "Krallenfassung", prongsRound: "Runde Krappen", bezelSetting: "Zargenfassung", metalType: "Metall", singleOptionOnly: "Nur eine Option möglich", modificationsSelected: "Änderung(en) ausgewählt", generateNewVersion: "Neue Version generieren", generationInProgress: "Wird generiert...", selectAtLeastOne: "Mindestens eine Änderung auswählen",
    myRequests: "Meine Anfragen", myCreationsTab: "Meine Kreationen", messaging: "Nachrichten", fabricationTracking: "Fertigungsverfolgung", faqHelp: "FAQ & Hilfe", mySpace: "Mein Bereich", logout: "Abmelden", noCreations: "Keine Kreationen", creationsWillAppear: "Ihre generierten Designs erscheinen hier.", noFabrication: "Keine Projekte in Fertigung", fabricationWillAppear: "Nach Angebotsbestätigung können Sie den Fortschritt hier verfolgen", estimatedDelivery: "Voraussichtliche Lieferung", writeMessage: "Nachricht schreiben...", messageSent: "Nachricht gesendet", noMessages: "Wir senden Ihnen Ihr Angebot innerhalb von 48 Stunden. Teilen Sie uns gerne alle Details zu Ihrer Kreation mit.", bonnotTeam: "Team Bonnot Paris", contactByEmail: "Per E-Mail kontaktieren",
    connection: "Anmelden", accessCreations: "Auf Ihre Kreationen zugreifen", createAccount: "Konto erstellen", saveDesigns: "Ihre Lieblingsdesigns speichern", forgotPassword: "Passwort vergessen?", forgotPasswordTitle: "Passwort vergessen", forgotPasswordDesc: "Geben Sie Ihre E-Mail ein, um einen Reset-Link zu erhalten", newPassword: "Neues Passwort", newPasswordDesc: "Wählen Sie Ihr neues Passwort", sendLink: "Link senden", resetPassword: "Passwort zurücksetzen", emailSent: "E-Mail gesendet!", emailSentDesc: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie einen Link zum Zurücksetzen.", backToLogin: "Zurück zur Anmeldung", noAccount: "Noch kein Konto?", alreadyAccount: "Bereits ein Konto?", connecting: "Anmeldung...", creating: "Erstellung...", sending: "Senden...", resetting: "Zurücksetzung...",
    personalizeDesign: "Personalisieren Sie Ihr Design", seeWorn: "Getragen ansehen", wornViewsGenerated: "Trageansichten generiert", generateWornViews: "Trageansichten generieren", tryOnHand: "An meiner Hand probieren", tryOnHandDesc: "Mit Ihrem Foto visualisieren", refineDesignBtn: "Design verfeinern", refineDesignDesc: "Details ändern", validateDesign: "Dieses Design bestätigen", designSaved: "Dieses Design wird in \"Meine Kreationen\" gespeichert", tip: "Tipp", tipSelection: "Klicken Sie auf das Design, das Ihnen am besten gefällt.", tipCustomization: "Nutzen Sie die Optionen, um das Design getragen zu sehen oder zu verfeinern.",
    stoneValidation: "Steinvalidierung", designValidation: "Designvalidierung", quoteValidation: "Angebotsvalidierung", depositPayment: "Anzahlung", waxCreation: "Wachsmodell-Erstellung", workshopFabrication: "Werkstattfertigung", photoShooting: "Ring-Fotoshooting", shippingDelivery: "Versand / Persönliche Übergabe", finalPayment: "Restzahlung", delivered: "Geliefert",
    stoneLabel: "Stein", designLabel: "Design", designChosen: "Ausgewählt", yourDesignLabel: "Ihr Design", notChosen: "Nicht gewählt", metalLabel: "Metall", sizeLabel: "Größe", sizeNotChosen: "Nicht gewählt", budgetLabel: "Budget", budgetDefined: "Festgelegt", budgetNotDefined: "Nicht festgelegt", generate: "Generieren", generating: "Generierung...",
    chooseYourStyle: "Wählen Sie Ihren Stil", chooseStyleDesc: "Wählen Sie das Design, das Ihnen am besten gefällt, und passen Sie es an.", clickToCustomize: "Klicken Sie auf ein Design zum Anpassen", optionsTitle: "Anpassungsoptionen", seeWornBtn: "Getragen ansehen", wornGenerated: "Trageansichten generiert", generateWorn: "Trageansichten generieren", tryOnBtn: "An meiner Hand probieren", tryOnDesc: "Mit Ihrem Foto visualisieren", refineBtn: "Design verfeinern", refineDesc: "Details ändern", validateBtn: "Kostenloses Angebot anfordern", savedInCreations: "Dieses Design wird in \"Meine Kreationen\" gespeichert", tipLabel: "Tipp", tipClickDesign: "Klicken Sie auf das Design, das Ihnen am besten gefällt.", designRefined: "Design verfeinert! Trageansichten wurden zurückgesetzt.", selectOneMod: "Mindestens eine Änderung auswählen", personalizeYourDesign: "Personalisieren Sie Ihr Design", generationSuccess: "Generierung erfolgreich!", generationError: "Fehler bei der Generierung", generatingImage: "Wird generiert...",
    loadingCreation: "Kreation läuft", loadingAI: "Unsere KI erstellt Ihre Designs", loadingStep1: "Analyse Ihres Edelsteins", loadingStep2: "Hauptdesign wird generiert (A)", loadingStep3: "Variationen werden erstellt (B & C)",
    virtualTryOn: "Virtuelles Anprobieren", visualizeOnHand: "Visualisieren Sie Ihren Ring an Ihrer Hand", yourHand: "IHRE HAND", yourRing: "IHR RING", changePhoto: "Foto ändern", generateTryOn: "Anprobe generieren", tryOnTip: "Für beste Ergebnisse fotografieren Sie Ihre Hand mit gespreizten Fingern auf neutralem Hintergrund.", result: "Ergebnis", uploadHandPhoto: "Foto Ihrer Hand hochladen",
    metalSectionTitle: "Metall", metalSectionSubtitle: "Wählen Sie Ihr Edelmetall", preciousStoneLabel: "Edelstein",
    logoutSuccess: "Erfolgreich abgemeldet", loginRequired: "Anmeldung erforderlich", upToChars: "Bis zu {max} Zeichen",
    accessDesigns: "Zugang zu Ihren Designs", connectOrCreate: "Melden Sie sich an oder erstellen Sie ein Konto", firstNameRequired: "Vorname erforderlich", passwordRequired: "Passwort erforderlich", passwordMinLength: "Mindestens 6 Zeichen", firstName: "Vorname", lastName: "Nachname", emailLabel: "E-Mail-Adresse", passwordLabel: "Passwort", yourPassword: "Ihr Passwort", phone: "Telefon",
    shape: "Form", weight: "Gewicht", dimensions: "Abmessungen", clarity: "Reinheit", treatment: "Behandlung", origin: "Herkunft", selectThisStone: "Diesen Stein auswählen", viewInShop: "Im Shop ansehen",
    yourText: "Ihr Text", fontStyle: "Schriftstil", classicFont: "Klassisch", elegantFont: "Elegant", cursiveFont: "Kursiv", engravingPlaceholder: "z.B.: Für immer", engravingSample: "Für immer", upToMaxChars: "Bis zu {max} Zeichen",
    confirmationTitle: "Wunderschön!", confirmationMessage: "Wir freuen uns, dieses Projekt mit Ihnen zu beginnen. Unser Team sendet Ihnen das Angebot innerhalb von 48 Stunden. Es wird in Ihren persönlichen Nachrichten verfügbar sein.", goToMessages: "Zu meinen Nachrichten", backToDesign: "Zurück zum Design",
  },
  
  es: {
    // Intro Page
    welcome: "Bienvenido a",
    tagline: "Sé el arquitecto del anillo de tus sueños",
    taglineSubtitleLine1: "La primera casa de joyería del mundo en poner la creación en tus manos:",
    taglineSubtitleLine2: "Desde la selección de tu piedra hasta la elección del diseño, visualiza tu creación puesta antes incluso del inicio de su fabricación en nuestros talleres.",
    startDesigning: "Comenzar a diseñar",
    discoverHouse: "Descubrir la Casa",
    signIn: "Iniciar sesión",
    signUp: "Registrarse",
    myCreations: "Mis Creaciones",
    myAccount: "Mi Espacio",
    logout: "Cerrar sesión",
    
    // About Page Hero
    aboutHeroSubtitle: "La primera casa de joyería del mundo en poner la creación en tus manos:",
    aboutHeroSubtitle2: "Desde la selección de tu piedra hasta la elección del diseño, visualiza tu creación puesta antes incluso del inicio de su fabricación en nuestros talleres.",
    createYourRing: "Crear tu anillo",
    
    // Creation Steps
    processLabel: "Proceso",
    creationStepsTitle: "Las etapas de creación",
    step: "Etapa",
    stoneChoiceTitle: "La elección de la piedra",
    stoneChoiceDesc: "Selecciona la piedra ideal entre nuestra amplia gama de zafiros, esmeraldas, rubíes, turmalinas, granates y muchos más. Todas nuestras piedras están certificadas por laboratorios reconocidos. Gracias a nuestras oficinas en India, Sri Lanka y Bangkok, en el corazón de los mercados y las minas, tenemos acceso privilegiado a las piedras más bellas.",
    designTitle: "El diseño",
    designDesc: "Selecciona el diseño que te corresponda o envíanos tus fotos de inspiración. Elige el metal y personaliza cada detalle de tu anillo. Y si el diseño final no te satisface completamente, nuestro diseñador puede crear una versión a medida, perfectamente adaptada a tus deseos y estilo.",
    manufacturingTitle: "La fabricación",
    manufacturingDesc: "Tu creación es realizada a mano en nuestros talleres en Tailandia, Italia y Francia por nuestros maestros artesanos. Sigue el progreso de la fabricación de tu anillo directamente desde tu espacio personal, desde el diseño hasta la entrega.",
    
    // FAQ
    faqLabel: "FAQ",
    faqTitle: "Preguntas frecuentes",
    faq1Question: "¿Cómo funciona la creación a medida?",
    faq1Answer: "Desde tu cuenta personal, accedes a nuestro espacio de discusión, donde puedes intercambiar directamente con nuestros equipos sobre tus deseos, tu historia y tu presupuesto. En este espacio, podrás realizar todas las modificaciones necesarias, ya sea la elección de la piedra o del diseño, para crear el anillo de tus sueños.\n\nNuestros expertos te guiarán en la selección de la piedra ideal para tu proyecto. Si el diseño generado no corresponde perfectamente a tus expectativas, nuestros diseñadores pueden intervenir para proponer creaciones completamente personalizadas. Una vez validados todos los elementos, tendrás acceso a tu presupuesto. Su validación desencadena la realización de tu anillo por nuestros maestros joyeros.",
    faq2Question: "¿Están certificadas sus piedras?",
    faq2Answer: "Sí, todas nuestras piedras están certificadas por laboratorios reconocidos como Bellerophon, ICA GemLab, London Gem Lab, y otros, garantizando su autenticidad y calidad excepcional.",
    faq3Question: "¿Cómo se entrega mi joya a medida?",
    faq3Answer: "La entrega se realiza en mano en París o a través de un transportista especializado, para garantizar un envío seguro, asegurado y completamente fiable hasta el destino.",
    faq4Question: "¿Cuáles son los plazos de creación?",
    faq4Answer: "El plazo de realización depende de la complejidad de la joya, pero generalmente se debe contar entre 4 y 8 semanas después de la validación del presupuesto.",
    faq5Question: "¿Puedo reutilizar mi oro para mi creación?",
    faq5Answer: "Ofrecemos un servicio de reciclaje y transformación de sus joyas. El oro de sus piezas existentes puede ser reutilizado para darles una nueva vida, en el corazón de una creación diseñada especialmente para usted.\n\nSi desea crear su joya a partir de su propio oro, le invitamos a indicarlo haciendo clic en el botón 'Deseo reutilizar mi oro para mi anillo' en la etapa 2, o directamente a través del espacio de discusión accesible desde su cuenta.",
    faq6Question: "¿Y si no puedo desplazarme a París?",
    faq6Answer: "Acompañamos a muchos clientes en toda Francia e internacionalmente. Desde tu espacio personal, puedes transmitirnos tus preguntas y dudas en cualquier momento. Nuestros equipos permanecen a tu disposición y te acompañan con atención durante todo el proceso de creación.",
    
    // Configure Page - Reuse Gold
    reuseGoldTitle: "Reutilizar tu oro",
    reuseGoldSubtitle: "Solo aceptamos oro 18k 750",
    reuseGoldToggle: "Deseo reutilizar mi oro para mi anillo",
    reuseGoldToggleDesc: "Fundiremos tu oro para crear tu nuevo anillo",
    goldWeightLabel: "Peso de tu oro (en gramos)",
    goldWeightPlaceholder: "Ej: 15",
    goldWeightHelp: "Si no conoces el peso exacto, deja este campo vacío. Lo determinaremos juntos.",
    
    // Configure Page - Metal
    metalTitle: "Metal",
    metalSubtitle: "Elige tu metal precioso",
    
    // Configure Page - Ring Size
    ringSizeTitle: "Talla de anillo",
    ringSizeSubtitle: "Talla estándar mujer: 53",
    ringSizeUnknown: "No conozco mi talla",
    
    // Configure Page - Budget
    budgetTitle: "Presupuesto",
    budgetSubtitle: "Estimación para tu proyecto",
    
    // About Page
    aboutTitle: "Maison Bonnot París",
    aboutSubtitle: "Alta Joyería desde 1987",
    aboutDescription1: "Durante más de 35 años, Maison Bonnot París ha encarnado la excelencia de la alta joyería francesa. Nuestro taller parisino perpetúa un saber hacer artesanal excepcional, transmitido de generación en generación.",
    aboutDescription2: "Cada creación es el resultado de una colaboración única entre nuestros maestros joyeros y usted. Desde la selección de la piedra preciosa hasta el diseño final, le acompañamos para dar vida al anillo de sus sueños.",
    aboutDescription3: "Gracias a nuestra tecnología de inteligencia artificial, visualice instantáneamente sus ideas y explore diseños personalizados antes de confiarlos a nuestros artesanos.",
    ourValues: "Nuestros Valores",
    valueExcellence: "Excelencia",
    valueExcellenceDesc: "Artesanía excepcional",
    valueCreativity: "Creatividad",
    valueCreativityDesc: "Diseños únicos y personalizados",
    valueQuality: "Calidad",
    valueQualityDesc: "Las piedras preciosas más bellas",
    backToHome: "Volver",
    readyToCreate: "¿Listo para crear?",
    
    // Navigation
    gemstone: "Gema",
    upload: "Piedra", design: "Diseño", configure: "Parámetros",
    designs: "Diseños",
    quote: "Cotización",
    
    // Gemstone Page
    selectGemstone: "Seleccione su piedra preciosa",
    uploadYourStone: "Suba su piedra",
    orChooseFromCatalog: "O elija de nuestro catálogo",
    continue: "Continuar",
    
    // Configuration Page
    selectMetal: "Elija su metal",
    yellowGold: "Oro Amarillo",
    whiteGold: "Oro Blanco",
    roseGold: "Oro Rosa",
    platinum: "Platino",
    selectInspiration: "Elija sus inspiraciones",
    generateDesigns: "Generar diseños",
    inspirationSelected: "1 inspiración seleccionada",
    
    // Results Page
    yourDesigns: "Sus Diseños",
    selectVariation: "Seleccione una variación",
    refine: "Refinar",
    wornView: "Vista puesta",
    virtualTryOn: "Prueba virtual",
    requestQuote: "Solicitar cotización",
    
    // Quote Page
    quoteRequest: "Solicitud de cotización",
    selectedDesign: "Diseño seleccionado",
    estimatedPrice: "Precio estimado",
    contactInfo: "Información de contacto",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    phone: "Teléfono",
    message: "Mensaje",
    submit: "Enviar",
    
    // Common
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    back: "Atrás",
    next: "Siguiente",
    
    // Language names
    langFrench: "Francés",
    langUSEnglish: "Inglés US",
    langUKEnglish: "Inglés UK",
    langGerman: "Alemán",
    langSpanish: "Español",
    ourCatalog: "Nuestro Catálogo", selectYourGemstone: "Seleccione su piedra preciosa", filters: "Filtros", filterType: "Tipo", filterPrice: "Precio", filterWeight: "Peso", filterShape: "Forma", filterClarity: "Claridad", filterTreatment: "Tratamiento", filterOrigin: "Origen", search: "Buscar", video: "Vídeo", continueBtn: "Continuar", backBtn: "Volver",
    stepLabel: "PASO", preciousStone: "PIEDRA PRECIOSA", configuration: "CONFIGURACIÓN", personalizeCreation: "Personalice Su Creación", selectPreferences: "Seleccione sus preferencias para crear el anillo perfecto", chooseYourStone: "Elija Su Piedra", yourChoices: "Sus elecciones",
    engravingTitle: "Grabado", engravingSubtitle: "Añada un mensaje personal dentro del anillo", addEngraving: "Añadir grabado", maxChars: "Hasta 20 caracteres",
    dontKnowSize: "No conozco mi talla", budgetTitle: "Presupuesto", budgetSubtitle: "Estimación para su proyecto", andMore: "y más",
    reuseGoldTitle: "Reutilizar su oro", reuseGoldSubtitle: "Fundir su antigua joya de oro", reuseGoldYes: "Sí, quiero reutilizar mi oro",
    creationInProgress: "Creando", aiGenerating: "Nuestra IA está generando sus diseños personalizados", analyzingStone: "Analizando su piedra preciosa", generatingMainDesign: "Generando diseño principal (A)", creatingVariations: "Creando variaciones (B & C)", estimatedTime: "Tiempo estimado", aboutSeconds: "aproximadamente 1 a 2 minutos",
    uploadTitle: "Su Inspiración", uploadDesc: "Elija un diseño Bonnot Paris o suba su propia inspiración.", copyrightWarning: "Para evitar la reproducción ilegal de anillos existentes, recomendamos usar nuestras inspiraciones Bonnot Paris o imágenes libres de derechos.", dropOrClick: "Arrastre su imagen o haga clic para subir", pngJpgPdf: "PNG, JPG, PDF — 1 imagen máximo", maxOneUpload: "Solo puede subir una inspiración.", alreadyUploadedInsp: "Ya ha subido su inspiración. Elimínela para elegir otra.",
    trustNoMiddleman: "Sin intermediarios", trustNoMiddlemanDesc: "La única casa de joyería con oficinas en Sri Lanka, India y Tailandia", trustNaturalStone: "Piedra natural", trustNaturalStoneDesc: "Nuestras gemas únicas reflejan la pureza y elegancia de la naturaleza", trustCertificate: "Entregada con certificado", trustCertificateDesc: "Exclusivamente por laboratorios independientes reconocidos", trustICA: "Miembro ICA", trustICADesc: "International Colored Gemstone Association", trustHandmade: "Hecha a mano", trustHandmadeDesc: "Cada joya en oro de 18 quilates, reflejo de nuestro compromiso de calidad", trustExpertise: "Saber hacer secular", trustExpertiseDesc: "Talleres con cientos de años de experiencia", trustResize: "Ajuste de talla gratuito", trustResizeDesc: "Ajuste gratuito para un confort perfecto",
    ourDesigns: "Nuestros Diseños", designsForShape: "diseño(s) para la forma de su piedra", selectStoneForDesigns: "Seleccione una piedra para ver los diseños", noDesignsForShape: "No hay diseños disponibles para esta forma", selectStoneToSee: "Seleccione una piedra para ver los diseños",
    yourInspiration: "Su Inspiración", addYourImage: "Añada su propia imagen de inspiración (PNG, JPEG, PDF)", oneImage: "1 imagen", complete: "Completo", alreadyUploaded: "Ya ha subido su inspiración. Elimínela para elegir otra.", dropImageHere: "Suelte su imagen aquí", dragOrClick: "Arrastre su imagen o haga clic para subir", oneImageMax: "PNG, JPG, PDF — 1 imagen máximo", chooseDesignOrUpload: "Elija un diseño Bonnot Paris o suba su propia inspiración.", copyrightNotice: "Para evitar la reproducción ilegal de anillos existentes, recomendamos usar nuestras inspiraciones Bonnot Paris o imágenes libres de derechos.",
    refineDesign: "Refinar diseño", selectModifications: "Seleccione las modificaciones deseadas", initialDesign: "Diseño inicial", bandStructure: "Estructura del aro", bandWithDiamonds: "Aro con diamantes", bandNoDiamonds: "Aro liso", removeAllPave: "Eliminar todo el pavé", secondaryStones: "Piedras secundarias", replaceColorWithDiamond: "Reemplazar piedras de color por diamantes", settingType: "Tipo de engaste", prongsEagle: "Garras de águila", prongsRound: "Garras redondas", bezelSetting: "Engaste cerrado", metalType: "Metal", singleOptionOnly: "Solo una opción posible", modificationsSelected: "modificación(es) seleccionada(s)", generateNewVersion: "Generar nueva versión", generationInProgress: "Generando...", selectAtLeastOne: "Seleccione al menos una modificación",
    myRequests: "Mis solicitudes", myCreationsTab: "Mis Creaciones", messaging: "Mensajería", fabricationTracking: "Seguimiento de fabricación", faqHelp: "FAQ y Ayuda", mySpace: "Mi Espacio", logout: "Cerrar sesión", noCreations: "Sin creaciones", creationsWillAppear: "Sus diseños generados aparecerán aquí.", noFabrication: "Ningún proyecto en fabricación", fabricationWillAppear: "Una vez validado su presupuesto, podrá seguir el avance aquí", estimatedDelivery: "Entrega estimada", writeMessage: "Escriba su mensaje...", messageSent: "Mensaje enviado", noMessages: "Le enviaremos su presupuesto en 48 horas. No dude en compartir todos los detalles sobre su creación.", bonnotTeam: "Equipo Bonnot Paris", contactByEmail: "Contáctenos por email",
    connection: "Iniciar sesión", accessCreations: "Acceda a sus creaciones", createAccount: "Crear cuenta", saveDesigns: "Guarde sus diseños favoritos", forgotPassword: "¿Olvidó su contraseña?", forgotPasswordTitle: "Contraseña olvidada", forgotPasswordDesc: "Ingrese su email para recibir un enlace de restablecimiento", newPassword: "Nueva contraseña", newPasswordDesc: "Elija su nueva contraseña", sendLink: "Enviar enlace", resetPassword: "Restablecer contraseña", emailSent: "¡Email enviado!", emailSentDesc: "Si existe una cuenta con este email, recibirá un enlace para restablecer su contraseña.", backToLogin: "Volver al inicio de sesión", noAccount: "¿Aún no tiene cuenta?", alreadyAccount: "¿Ya tiene una cuenta?", connecting: "Conectando...", creating: "Creando...", sending: "Enviando...", resetting: "Restableciendo...",
    personalizeDesign: "Personalice su diseño", seeWorn: "Ver puesto", wornViewsGenerated: "Vistas generadas", generateWornViews: "Generar vistas", tryOnHand: "Probar en mi mano", tryOnHandDesc: "Visualizar con su foto", refineDesignBtn: "Refinar diseño", refineDesignDesc: "Modificar detalles", validateDesign: "Validar este diseño", designSaved: "Este diseño se guardará en \"Mis Creaciones\"", tip: "Consejo", tipSelection: "Haga clic en el diseño que más le guste para personalizarlo.", tipCustomization: "Use las opciones para ver el diseño puesto o refinarlo antes de validar.",
    stoneValidation: "Validación de la piedra", designValidation: "Validación del diseño", quoteValidation: "Validación del presupuesto", depositPayment: "Pago del anticipo", waxCreation: "Creación del modelo en cera", workshopFabrication: "Fabricación en talleres", photoShooting: "Sesión fotográfica del anillo", shippingDelivery: "Envío / Entrega en mano", finalPayment: "Pago del saldo", delivered: "Entregado",
    stoneLabel: "Piedra", designLabel: "Diseño", designChosen: "Seleccionado", yourDesignLabel: "Su diseño", notChosen: "No elegido", metalLabel: "Metal", sizeLabel: "Talla", sizeNotChosen: "No elegida", budgetLabel: "Presupuesto", budgetDefined: "Definido", budgetNotDefined: "No definido", generate: "Generar", generating: "Generando...",
    chooseYourStyle: "Elija Su Estilo", chooseStyleDesc: "Seleccione el diseño que más le guste y adáptelo a su gusto.", clickToCustomize: "Haga clic en un diseño para personalizarlo", optionsTitle: "Opciones de personalización", seeWornBtn: "Ver puesto", wornGenerated: "Vistas generadas", generateWorn: "Generar vistas", tryOnBtn: "Probar en mi mano", tryOnDesc: "Visualizar con su foto", refineBtn: "Refinar diseño", refineDesc: "Modificar detalles", validateBtn: "Solicitar mi presupuesto gratuito", savedInCreations: "Este diseño se guardará en \"Mis Creaciones\"", tipLabel: "Consejo", tipClickDesign: "Haga clic en el diseño que más le guste para personalizarlo.", designRefined: "¡Diseño refinado! Las vistas se han reiniciado.", selectOneMod: "Seleccione al menos una modificación", personalizeYourDesign: "Personalice su diseño", generationSuccess: "¡Generación exitosa!", generationError: "Error durante la generación", generatingImage: "Generando...",
    loadingCreation: "Creando", loadingAI: "Nuestra IA genera sus diseños personalizados", loadingStep1: "Analizando su piedra preciosa", loadingStep2: "Generando diseño principal (A)", loadingStep3: "Creando variaciones (B & C)",
    virtualTryOn: "Prueba Virtual", visualizeOnHand: "Visualice su anillo en su mano", yourHand: "SU MANO", yourRing: "SU ANILLO", changePhoto: "Cambiar foto", generateTryOn: "Generar prueba", tryOnTip: "Para mejores resultados, tome una foto de su mano con los dedos separados sobre un fondo neutro.", result: "Resultado", uploadHandPhoto: "Suba una foto de su mano",
    metalSectionTitle: "Metal", metalSectionSubtitle: "Elija su metal precioso", preciousStoneLabel: "Piedra Preciosa",
    logoutSuccess: "Sesión cerrada", loginRequired: "Inicio de sesión requerido", upToChars: "Hasta {max} caracteres",
    accessDesigns: "Acceda a sus Diseños", connectOrCreate: "Inicie sesión o cree una cuenta para ver sus creaciones", firstNameRequired: "Nombre requerido", passwordRequired: "Contraseña requerida", passwordMinLength: "Mínimo 6 caracteres", firstName: "Nombre", lastName: "Apellido", emailLabel: "Correo electrónico", passwordLabel: "Contraseña", yourPassword: "Su contraseña", phone: "Teléfono",
    shape: "Forma", weight: "Peso", dimensions: "Dimensiones", clarity: "Claridad", treatment: "Tratamiento", origin: "Origen", selectThisStone: "Seleccionar esta piedra", viewInShop: "Ver en la tienda",
    yourText: "Su texto", fontStyle: "Estilo de fuente", classicFont: "Clásico", elegantFont: "Elegante", cursiveFont: "Cursivo", engravingPlaceholder: "ej: Para siempre", engravingSample: "Para siempre", upToMaxChars: "Hasta {max} caracteres",
    confirmationTitle: "¡Magnífico!", confirmationMessage: "Estamos deseando empezar este proyecto con usted. Nuestro equipo le enviará el presupuesto en 48 horas. Estará disponible en su mensajería personal.", goToMessages: "Ir a mi mensajería", backToDesign: "Volver al diseño",
  },
};

// Currency configuration
const currencies = {
  fr: { code: 'EUR', symbol: '€', position: 'after', locale: 'fr-FR' },
  en_US: { code: 'USD', symbol: '$', position: 'before', locale: 'en-US' },
  en_GB: { code: 'GBP', symbol: '£', position: 'before', locale: 'en-GB' },
  de: { code: 'EUR', symbol: '€', position: 'after', locale: 'de-DE' },
  es: { code: 'EUR', symbol: '€', position: 'after', locale: 'es-ES' },
};

// Language options for selector
const languageOptions = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en_US', name: 'Américain', flag: '🇺🇸' },
  { code: 'en_GB', name: 'Anglais', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
];

// Exchange rates (EUR as base)
const exchangeRates = {
  EUR: 1,
  USD: 1.08,
  GBP: 0.86,
};

const LocaleContext = createContext();

export function LocaleProvider({ children }) {
  // Get saved language or default to French
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('bonnot_language');
    return saved || 'fr';
  });

  // Save language to localStorage
  useEffect(() => {
    localStorage.setItem('bonnot_language', language);
  }, [language]);

  // Get current currency config
  const currency = currencies[language] || currencies.fr;

  // Translation function
  function t(key) {
    const langTranslations = translations[language] || translations.fr;
    return langTranslations[key] || translations.fr[key] || key;
  }

  // Format price with currency conversion
  function formatPrice(amountInEUR, options = {}) {
    const { showCurrency = true, decimals = 2, compact = false } = options;
    
    // Convert from EUR to target currency
    const rate = exchangeRates[currency.code] || 1;
    const convertedAmount = amountInEUR * rate;
    
    // Compact format for large numbers
    if (compact && convertedAmount >= 1000) {
      const k = convertedAmount / 1000;
      const formattedK = k >= 10 ? Math.round(k) : k.toFixed(k % 1 === 0 ? 0 : 1);
      if (currency.position === 'before') {
        return `${currency.symbol}${formattedK}k`;
      } else {
        return `${formattedK}k ${currency.symbol}`;
      }
    }
    
    // Format number
    const formattedNumber = new Intl.NumberFormat(currency.locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(convertedAmount);
    
    if (!showCurrency) {
      return formattedNumber;
    }
    
    // Add currency symbol
    if (currency.position === 'before') {
      return `${currency.symbol}${formattedNumber}`;
    } else {
      return `${formattedNumber} ${currency.symbol}`;
    }
  }

  // Get raw converted amount
  function convertPrice(amountInEUR) {
    const rate = exchangeRates[currency.code] || 1;
    return amountInEUR * rate;
  }

  const value = {
    language,
    setLanguage,
    currency,
    t,
    formatPrice,
    convertPrice,
    languageOptions,
    exchangeRates,
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
}

export default LocaleContext;
